export const albums1001 = [
    {
        id: 1,
        artist: "Frank Sinatra",
        album: "In the Wee Small Hours",
        year: "1955",
        cover: "https://www.listchallenges.com/f/items/eb87ff55-0be4-41b6-88b7-b6858668fe70.jpg"
    },
    {
        id: 2,
        artist: "Elvis Presley",
        album: "Elvis Presley",
        year: "1956",
        cover: "https://www.listchallenges.com/f/items/5a33631d-6360-4666-b668-e6246930991d.jpg"
    },
    {
        id: 3,
        artist: "The Louvin Brothers",
        album: "Tragic Songs of Life",
        year: "1956",
        cover: "https://www.listchallenges.com/f/items/3eb328b3-0a42-4281-861b-38f09c464ffa.jpg"
    },
    {
        id: 4,
        artist: "Louis Prima",
        album: "The Wildest!",
        year: "1956",
        cover: "https://www.listchallenges.com/f/items/bd3116fc-6ce8-448c-9618-f9d2fc3d85ae.jpg"
    },
    {
        id: 5,
        artist: "Fats Domino",
        album: "This Is Fats",
        year: "1956",
        cover: "https://www.listchallenges.com/f/items/d179f50b-4a86-4d4d-957e-d02c58c81779.jpg"
    },
    {
        id: 6,
        artist: "Frank Sinatra",
        album: "Songs for Swinging Lovers!",
        year: "1956",
        cover: "https://www.listchallenges.com/f/items/890186cf-0a4e-4db8-a8fe-7cf22c58aafa.jpg"
    },
    {
        id: 7,
        artist: "Duke Ellington",
        album: "Ellington at Newport '56",
        year: "1956",
        cover: "https://www.listchallenges.com/f/items/0c8fcb17-9cfc-4202-8cdc-93d8bf21f7d3.jpg"
    },
    {
        id: 8,
        artist: "Count Basie",
        album: "The Atomic Mr Basie",
        year: "1958",
        cover: "https://www.listchallenges.com/f/items/b6cf6f62-b68d-43c1-8d76-f2421e29c07f.jpg"
    },
    {
        id: 9,
        artist: "Miles Davis",
        album: "Birth of the Cool",
        year: "None",
        cover: "None"
    },
    {
        id: 10,
        artist: "Sabu",
        album: "Palo Congo",
        year: "1957",
        cover: "None"
    },
    {
        id: 11,
        artist: "Thelonious Monk",
        album: "Brilliant Corners",
        year: "None",
        cover: "None"
    },
    {
        id: 12,
        artist: "Machito",
        album: "Kenya",
        year: "None",
        cover: "None"
    },
    {
        id: 13,
        artist: "Little Richard",
        album: "Here's Little Richard",
        year: "None",
        cover: "None"
    },
    {
        id: 14,
        artist: "Buddy Holly and the Crickets",
        album: "The 'Chirping' Crickets",
        year: "None",
        cover: "None"
    },
    {
        id: 15,
        artist: "Tito Puente",
        album: "Dance Mania",
        year: "None",
        cover: "None"
    },
    {
        id: 16,
        artist: "Billie Holiday",
        album: "Lady in Satin",
        year: "None",
        cover: "None"
    },
    {
        id: 17,
        artist: "Ramblin' Jack Elliott",
        album: "Jack Takes the Floor",
        year: "None",
        cover: "None"
    },
    {
        id: 18,
        artist: "Sarah Vaughan",
        album: "Sarah Vaughan at Mister Kelly's",
        year: "1958",
        cover: "None"
    },
    {
        id: 19,
        artist: "Ella Fitzgerald",
        album: "Sings the Gershwin Song Book",
        year: "1959",
        cover: "None"
    },
    {
        id: 20,
        artist: "Miles Davis",
        album: "Kind of Blue",
        year: "1959",
        cover: "None"
    },
    {
        id: 21,
        artist: "Ray Charles",
        album: "Genius of Ray Charles",
        year: "None",
        cover: "None"
    },
    {
        id: 22,
        artist: "Marty Robbins",
        album: "Gunfighter Ballads and Trail Songs",
        year: "1959",
        cover: "None"
    },
    {
        id: 23,
        artist: "The Dave Brubeck Quartet",
        album: "Time Out",
        year: "1959",
        cover: "None"
    },
    {
        id: 24,
        artist: "Elvis Presley",
        album: "Elvis Is Back!",
        year: "None",
        cover: "None"
    },
    {
        id: 25,
        artist: "Joan Baez",
        album: "Joan Baez",
        year: "1960",
        cover: "None"
    },
    {
        id: 26,
        artist: "Miriam Makeba",
        album: "Miriam Makeba",
        year: "1960",
        cover: "None"
    },
    {
        id: 27,
        artist: "Bill Evans",
        album: "Sunday at the Village Vanguard",
        year: "None",
        cover: "None"
    },
    {
        id: 28,
        artist: "Muddy Waters",
        album: "Muddy Waters at Newport",
        year: "1960",
        cover: "None"
    },
    {
        id: 29,
        artist: "The Everly Brothers",
        album: "A Date With the Everly Brothers",
        year: "None",
        cover: "None"
    },
    {
        id: 30,
        artist: "Stan Getz & Charlie Byrd",
        album: "Jazz Samba",
        year: "None",
        cover: "None"
    },
    {
        id: 31,
        artist: "Booker T. & the M.G.'S",
        album: "Green Onions",
        year: "1962",
        cover: "None"
    },
    {
        id: 32,
        artist: "Ray Charles",
        album: "Modern Sounds in Country and Western Music",
        year: "1962",
        cover: "None"
    },
    {
        id: 33,
        artist: "Jimmy Smith",
        album: "Back at the Chicken Shack",
        year: "None",
        cover: "None"
    },
    {
        id: 34,
        artist: "Ray Price",
        album: "Night Life",
        year: "None",
        cover: "None"
    },
    {
        id: 35,
        artist: "The Beatles",
        album: "With the Beatles",
        year: "None",
        cover: "None"
    },
    {
        id: 36,
        artist: "Various Artists",
        album: "A Christmas Gift for You",
        year: "None",
        cover: "None"
    },
    {
        id: 37,
        artist: "Sam Cooke",
        album: "Live at the Harlem Square Club",
        year: "None",
        cover: "None"
    },
    {
        id: 38,
        artist: "Bob Dylan",
        album: "The Freewheelin' Bob Dylan",
        year: "1963",
        cover: "None"
    },
    {
        id: 39,
        artist: "James Brown",
        album: "Live at the Apollo",
        year: "1963",
        cover: "None"
    },
    {
        id: 40,
        artist: "Charles Mingus",
        album: "The Black Saint and the Sinner Lady",
        year: "None",
        cover: "None"
    },
    {
        id: 41,
        artist: "The Beatles",
        album: "A Hard Day's Night",
        year: "1964",
        cover: "https://www.listchallenges.com/f/items/30619de5-7573-4c8c-bf2c-ebb05266c721.jpg"
    },
    {
        id: 42,
        artist: "Jacques Brel",
        album: "Olympia '64",
        year: "1964",
        cover: "https://www.listchallenges.com/f/items/3cb4c812-b313-43c5-8943-7446b75d6afd.jpg"
    },
    {
        id: 43,
        artist: "Solomon Burke",
        album: "Rock & Soul",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/4252f5b3-8821-4041-aef2-12d2e3672fd6.jpg"
    },
    {
        id: 44,
        artist: "Stan Getz & João Gilberto",
        album: "Getz/Gilberto",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/c2e28630-0370-4a14-ab80-6df4ec936736.jpg"
    },
    {
        id: 45,
        artist: "Dusty Springfield",
        album: "A Girl Called Dusty",
        year: "1964",
        cover: "https://www.listchallenges.com/f/items/06fcd7b1-a421-47da-8ed5-530387379242.jpg"
    },
    {
        id: 46,
        artist: "The Rolling Stones",
        album: "The Rolling Stones",
        year: "1964",
        cover: "https://www.listchallenges.com/f/items/762db4be-cb2f-47c7-a5c4-4a83230bf1d2.jpg"
    },
    {
        id: 47,
        artist: "Buck Owens and His Buckaroos",
        album: "I've Got a Tiger by the Tail",
        year: "1964",
        cover: "https://www.listchallenges.com/f/items/32576728-ae7e-4f9d-8172-30f631bd9d83.jpg"
    },
    {
        id: 48,
        artist: "Jerry Lee Lewis",
        album: "Live at the Star Club Hamburg",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/d1b3c1b4-aa13-46fd-bd48-f0797bf7177e.jpg"
    },
    {
        id: 49,
        artist: "The Sonics",
        album: "Here Are the Sonics",
        year: "None",
        cover: "None"
    },
    {
        id: 50,
        artist: "Bob Dylan",
        album: "Bringing It All Back Home",
        year: "None",
        cover: "None"
    },
    {
        id: 51,
        artist: "Otis Redding",
        album: "Otis Blue: Otis Redding Sings Soul",
        year: "None",
        cover: "None"
    },
    {
        id: 52,
        artist: "The Beach Boys",
        album: "The Beach Boys Today!",
        year: "1965",
        cover: "None"
    },
    {
        id: 53,
        artist: "John Coltrane",
        album: "A Love Supreme",
        year: "1965",
        cover: "None"
    },
    {
        id: 54,
        artist: "B.B. King",
        album: "Live at the Regal",
        year: "None",
        cover: "None"
    },
    {
        id: 55,
        artist: "The Beatles",
        album: "Rubber Soul",
        year: "1965",
        cover: "None"
    },
    {
        id: 56,
        artist: "Bert Jansch",
        album: "Bert Jansch",
        year: "None",
        cover: "None"
    },
    {
        id: 57,
        artist: "The Byrds",
        album: "Mr. Tambourine Man",
        year: "None",
        cover: "None"
    },
    {
        id: 58,
        artist: "Bob Dylan",
        album: "Highway 61 Revisited",
        year: "1965",
        cover: "None"
    },
    {
        id: 59,
        artist: "The Who",
        album: "My Generation",
        year: "None",
        cover: "None"
    },
    {
        id: 60,
        artist: "The Beatles",
        album: "Revolver",
        year: "1966",
        cover: "None"
    },
    {
        id: 61,
        artist: "The Beach Boys",
        album: "Pet Sounds",
        year: "1966",
        cover: "None"
    },
    {
        id: 62,
        artist: "Fred Neil",
        album: "Fred Neil",
        year: "None",
        cover: "None"
    },
    {
        id: 63,
        artist: "The Byrds",
        album: "Fifth Dimension",
        year: "None",
        cover: "None"
    },
    {
        id: 64,
        artist: "Bob Dylan",
        album: "Blonde on Blonde",
        year: "1966",
        cover: "None"
    },
    {
        id: 65,
        artist: "The Monks",
        album: "Black Monk Time",
        year: "1966",
        cover: "None"
    },
    {
        id: 66,
        artist: "The Kinks",
        album: "Face to Face",
        year: "None",
        cover: "None"
    },
    {
        id: 67,
        artist: "The Mamas & the Papas",
        album: "If You Can Believe Your Eyes and Ears",
        year: "None",
        cover: "None"
    },
    {
        id: 68,
        artist: "Paul Revere & the Raiders",
        album: "Midnight Ride",
        year: "1966",
        cover: "None"
    },
    {
        id: 69,
        artist: "The Mothers of Invention",
        album: "Freak Out!",
        year: "None",
        cover: "None"
    },
    {
        id: 70,
        artist: "The Rolling Stones",
        album: "Aftermath",
        year: "1966",
        cover: "None"
    },
    {
        id: 71,
        artist: "Simon & Garfunkel",
        album: "Parsley, Sage, Rosemary, & Thyme",
        year: "None",
        cover: "None"
    },
    {
        id: 72,
        artist: "13th Floor Elevators",
        album: "The Psychedelic Sounds of the 13th Floor Elevators",
        year: "1966",
        cover: "None"
    },
    {
        id: 73,
        artist: "John Mayall & the Bluesbreakers",
        album: "Blues Breakers",
        year: "None",
        cover: "None"
    },
    {
        id: 74,
        artist: "The Yardbirds",
        album: "Roger the Engineer",
        year: "None",
        cover: "None"
    },
    {
        id: 75,
        artist: "Nina Simone",
        album: "Wild Is the Wind",
        year: "None",
        cover: "None"
    },
    {
        id: 76,
        artist: "Astrud Gilberto",
        album: "Beach Samba",
        year: "None",
        cover: "None"
    },
    {
        id: 77,
        artist: "Nico",
        album: "Chelsea Girl",
        year: "1967",
        cover: "None"
    },
    {
        id: 78,
        artist: "The Beatles",
        album: "Sgt. Pepper's Lonely Hearts Club Band",
        year: "1967",
        cover: "None"
    },
    {
        id: 79,
        artist: "Country Joe & the Fish",
        album: "Electric Music for the Mind and Body",
        year: "None",
        cover: "None"
    },
    {
        id: 80,
        artist: "None",
        album: "None",
        year: "None",
        cover: "None"
    },
    {
        id: 81,
        artist: "Captain Beefheart & His Magic Band",
        album: "Safe as Milk",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/e8928a7d-5cae-4414-b417-4bbff3e7d51c.jpg"
    },
    {
        id: 82,
        artist: "Moby Grape",
        album: "Moby Grape",
        year: "1967",
        cover: "https://www.listchallenges.com/f/items/691d63b6-bbb2-4abd-95bb-e2668bd0b8aa.jpg"
    },
    {
        id: 83,
        artist: "Love",
        album: "Da Capo",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/9f330503-c213-4411-bc7f-84f6fd584faf.jpg"
    },
    {
        id: 84,
        artist: "Beau Brummels",
        album: "(The) Triangle",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/39d76580-7520-482b-a005-07202ab6ee4b.jpg"
    },
    {
        id: 85,
        artist: "The Monkees",
        album: "Headquarters",
        year: "1967",
        cover: "https://www.listchallenges.com/f/items/3d2e7dfc-b33d-4d5b-a4ef-51806cad8ca1.jpg"
    },
    {
        id: 86,
        artist: "Tim Buckley",
        album: "Goodbye and Hello",
        year: "1967",
        cover: "https://www.listchallenges.com/f/items/f3f3e00d-2e32-4bda-9e86-0ac3ab57f60f.jpg"
    },
    {
        id: 87,
        artist: "Love",
        album: "Forever Changes",
        year: "1967",
        cover: "https://www.listchallenges.com/f/items/f23fcbf8-bd8f-4036-a096-31d42c61bfac.jpg"
    },
    {
        id: 88,
        artist: "Cream",
        album: "Disraeli Gears",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/fef3d382-b1ad-48ff-b767-08dbcc773047.jpg"
    },
    {
        id: 89,
        artist: "Pink Floyd",
        album: "The Piper at the Gates of Dawn",
        year: "1967",
        cover: "None"
    },
    {
        id: 90,
        artist: "The Who",
        album: "The Who Sell Out",
        year: "1967",
        cover: "None"
    },
    {
        id: 91,
        artist: "The Velvet Underground and Nico",
        album: "The Velvet Underground & Nico",
        year: "1967",
        cover: "None"
    },
    {
        id: 92,
        artist: "Frank Sinatra, Antônio Carlos Jobim",
        album: "Francis Albert Sinatra & Antonio Carlos Jobim (50th Anniversary Edition)",
        year: "1967",
        cover: "None"
    },
    {
        id: 93,
        artist: "The Doors",
        album: "The Doors",
        year: "None",
        cover: "None"
    },
    {
        id: 94,
        artist: "The Byrds",
        album: "Younger Than Yesterday",
        year: "None",
        cover: "None"
    },
    {
        id: 95,
        artist: "The Young Rascals",
        album: "Groovin'",
        year: "1967",
        cover: "None"
    },
    {
        id: 96,
        artist: "Jefferson Airplane",
        album: "Surrealistic Pillow",
        year: "1967",
        cover: "None"
    },
    {
        id: 97,
        artist: "The Kinks",
        album: "Something Else by the Kinks",
        year: "None",
        cover: "None"
    },
    {
        id: 98,
        artist: "Donovan",
        album: "Sunshine Superman",
        year: "1967",
        cover: "None"
    },
    {
        id: 99,
        artist: "Merle Haggard",
        album: "I'm a Lonesome Fugitive",
        year: "1967",
        cover: "None"
    },
    {
        id: 100,
        artist: "Jimi Hendrix",
        album: "Are You Experienced?",
        year: "None",
        cover: "None"
    },
    {
        id: 101,
        artist: "The Electric Prunes",
        album: "The Electric Prunes",
        year: "1967",
        cover: "None"
    },
    {
        id: 102,
        artist: "Loretta Lynn",
        album: "Don't Come Home a Drinkin' (With Lovin' on Your Mind)",
        year: "None",
        cover: "None"
    },
    {
        id: 103,
        artist: "Shivkumar Sharma",
        album: "Call of the Valley",
        year: "1967",
        cover: "None"
    },
    {
        id: 104,
        artist: "The Velvet Underground",
        album: "White Light/White Heat",
        year: "1968",
        cover: "None"
    },
    {
        id: 105,
        artist: "Jimi Hendrix",
        album: "Axis: Bold as Love",
        year: "1967",
        cover: "None"
    },
    {
        id: 106,
        artist: "Aretha Franklin",
        album: "I Never Loved a Man the Way I Love You",
        year: "1967",
        cover: "None"
    },
    {
        id: 107,
        artist: "The Rolling Stones",
        album: "Beggars Banquet",
        year: "None",
        cover: "None"
    },
    {
        id: 108,
        artist: "Traffic",
        album: "Traffic",
        year: "1968",
        cover: "None"
    },
    {
        id: 109,
        artist: "The Incredible String Band",
        album: "The Hangman's Beautiful Daughter",
        year: "1968",
        cover: "None"
    },
    {
        id: 110,
        artist: "The Kinks",
        album: "The Kinks Are the Village Green Preservation Society",
        year: "None",
        cover: "None"
    },
    {
        id: 111,
        artist: "Ravi Shankar",
        album: "The Sounds of India",
        year: "1968",
        cover: "None"
    },
    {
        id: 112,
        artist: "Os Mutantes",
        album: "Os Mutantes",
        year: "1968",
        cover: "None"
    },
    {
        id: 113,
        artist: "Jimi Hendrix",
        album: "Electric Ladyland",
        year: "1968",
        cover: "None"
    },
    {
        id: 114,
        artist: "Leonard Cohen",
        album: "Songs of Leonard Cohen",
        year: "None",
        cover: "None"
    },
    {
        id: 115,
        artist: "Johnny Cash",
        album: "At Folsom Prison",
        year: "1968",
        cover: "None"
    },
    {
        id: 116,
        artist: "Laura Nyro",
        album: "Eli and the Thirteenth Confession",
        year: "None",
        cover: "None"
    },
    {
        id: 117,
        artist: "Aretha Franklin",
        album: "Lady Soul",
        year: "1968",
        cover: "None"
    },
    {
        id: 118,
        artist: "Blue Cheer",
        album: "Vincebus Eruptum",
        year: "1968",
        cover: "None"
    },
    {
        id: 119,
        artist: "The Byrds",
        album: "The Notorious Byrd Brothers",
        year: "None",
        cover: "None"
    },
    {
        id: 120,
        artist: "Big Brother and the Holding Company",
        album: "Cheap Thrills",
        year: "1968",
        cover: "None"
    },
    {
        id: 121,
        artist: "United States of America",
        album: "United States of America",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/f92e2e2f-36e0-4e3d-b2dc-e2cc56c20881.jpg"
    },
    {
        id: 122,
        artist: "Dr. John the Nighttripper",
        album: "Gris-Gris",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/b39845ce-8afd-4fbd-98fc-9401df12cd21.jpg"
    },
    {
        id: 123,
        artist: "Iron Butterfly",
        album: "In-A-Gadda-Da-Vida",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/1d3d8947-d4ee-40f3-9118-bac9b30db73a.jpg"
    },
    {
        id: 124,
        artist: "The Pretty Things",
        album: "S.F. Sorrow",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/115baaf0-d073-4e51-92de-2b0e6233a63c.jpg"
    },
    {
        id: 125,
        artist: "Simon & Garfunkel",
        album: "Bookends",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/888e6bd3-600e-4c1b-a90a-6fc467c1fcf1.jpg"
    },
    {
        id: 126,
        artist: "Small Faces",
        album: "Ogden's Nut Gone Flake",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/114ae2ad-1373-4d55-acaa-8af9894df945.jpg"
    },
    {
        id: 127,
        artist: "The Band",
        album: "Music From Big Pink",
        year: "1968",
        cover: "https://www.listchallenges.com/f/items/4ce6b0c0-c1cf-4a1b-8a49-396b711ef0b9.jpg"
    },
    {
        id: 128,
        artist: "Jeff Beck",
        album: "Truth",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/ae496145-992c-4ed0-a862-969958345b7b.jpg"
    },
    {
        id: 129,
        artist: "Caetano Veloso",
        album: "Caetano Veloso",
        year: "None",
        cover: "None"
    },
    {
        id: 130,
        artist: "Scott Walker",
        album: "Scott 2",
        year: "None",
        cover: "None"
    },
    {
        id: 131,
        artist: "The Zombies",
        album: "Odessey and Oracle",
        year: "1968",
        cover: "None"
    },
    {
        id: 132,
        artist: "Van Morrison",
        album: "Astral Weeks",
        year: "1968",
        cover: "None"
    },
    {
        id: 133,
        artist: "The Byrds",
        album: "Sweetheart of the Rodeo",
        year: "1968",
        cover: "None"
    },
    {
        id: 134,
        artist: "The Beatles",
        album: "The Beatles (White Album)",
        year: "None",
        cover: "None"
    },
    {
        id: 135,
        artist: "Mothers of Invention",
        album: "We're Only in It for the Money",
        year: "None",
        cover: "None"
    },
    {
        id: 136,
        artist: "Neil Young",
        album: "Everybody Knows This Is Nowhere",
        year: "1969",
        cover: "None"
    },
    {
        id: 137,
        artist: "Captain Beefheart & His Magic Band",
        album: "Trout Mask Replica",
        year: "1969",
        cover: "None"
    },
    {
        id: 138,
        artist: "Creedence Clearwater Revival",
        album: "Bayou Country",
        year: "1969",
        cover: "None"
    },
    {
        id: 139,
        artist: "Crosby, Stills & Nash",
        album: "Crosby, Stills & Nash",
        year: "1969",
        cover: "None"
    },
    {
        id: 140,
        artist: "Blood, Sweat & Tears",
        album: "Blood, Sweat & Tears",
        year: "1969",
        cover: "None"
    },
    {
        id: 141,
        artist: "The Flying Burrito Bros",
        album: "The Gilded Palace of Sin",
        year: "None",
        cover: "None"
    },
    {
        id: 142,
        artist: "Johnny Cash",
        album: "At San Quentin",
        year: "1969",
        cover: "None"
    },
    {
        id: 143,
        artist: "Creedence Clearwater Revival",
        album: "Green River",
        year: "None",
        cover: "None"
    },
    {
        id: 144,
        artist: "The Beatles",
        album: "Abbey Road",
        year: "1969",
        cover: "None"
    },
    {
        id: 145,
        artist: "The Who",
        album: "Tommy",
        year: "1969",
        cover: "None"
    },
    {
        id: 146,
        artist: "Miles Davis",
        album: "In a Silent Way",
        year: "1969",
        cover: "None"
    },
    {
        id: 147,
        artist: "Bee Gees",
        album: "Odessa",
        year: "1969",
        cover: "None"
    },
    {
        id: 148,
        artist: "Pentangle",
        album: "Basket of Light",
        year: "1969",
        cover: "None"
    },
    {
        id: 149,
        artist: "The Rolling Stones",
        album: "Let It Bleed",
        year: "1969",
        cover: "None"
    },
    {
        id: 150,
        artist: "Nick Drake",
        album: "Five Leaves Left",
        year: "1969",
        cover: "None"
    },
    {
        id: 151,
        artist: "Dusty Springfield",
        album: "Dusty in Memphis",
        year: "1969",
        cover: "None"
    },
    {
        id: 152,
        artist: "Elvis Presley",
        album: "From Elvis in Memphis",
        year: "1969",
        cover: "None"
    },
    {
        id: 153,
        artist: "The Velvet Underground",
        album: "The Velvet Underground",
        year: "None",
        cover: "None"
    },
    {
        id: 154,
        artist: "Quicksilver Messenger Service",
        album: "Happy Trails",
        year: "None",
        cover: "None"
    },
    {
        id: 155,
        artist: "Led Zeppelin",
        album: "Led Zeppelin",
        year: "None",
        cover: "None"
    },
    {
        id: 156,
        artist: "The Band",
        album: "The Band",
        year: "1969",
        cover: "None"
    },
    {
        id: 157,
        artist: "Led Zeppelin",
        album: "Led Zeppelin II",
        year: "1969",
        cover: "None"
    },
    {
        id: 158,
        artist: "MC5",
        album: "Kick Out the Jams",
        year: "1969",
        cover: "None"
    },
    {
        id: 159,
        artist: "The Temptations",
        album: "Cloud Nine",
        year: "1969",
        cover: "None"
    },
    {
        id: 160,
        artist: "Sly & the Family Stone",
        album: "Stand!",
        year: "1969",
        cover: "None"
    },
    {
        id: 161,
        artist: "Tim Buckley",
        album: "Happy Sad",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/22515440-ca27-4bce-ba60-8f521c95d3c3.jpg"
    },
    {
        id: 162,
        artist: "Chicago",
        album: "Chicago Transit Authority",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/3c680c28-acc3-45de-a12b-d9dbee9ecd49.jpg"
    },
    {
        id: 163,
        artist: "Fairport Convention",
        album: "Unhalfbricking",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/8fb03375-ea85-43f3-b541-08c659e1f644.jpg"
    },
    {
        id: 164,
        artist: "Youngbloods",
        album: "Elephant Mountain",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/a1a0dc5a-c118-4e18-a7db-f6a8cd6b2dd8.jpg"
    },
    {
        id: 165,
        artist: "Isaac Hayes",
        album: "Hot Buttered Soul",
        year: "1969",
        cover: "https://www.listchallenges.com/f/items/656727f2-b5e6-4615-98f5-95eddd535bd2.jpg"
    },
    {
        id: 166,
        artist: "Grateful Dead",
        album: "Live Dead",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/628118a4-1f7c-4375-b384-f8d701270ddf.jpg"
    },
    {
        id: 167,
        artist: "The Kinks",
        album: "Arthur or the Decline and Fall of the British Empire",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/5a0188ab-9735-4e3a-b4af-5055db90dc85.jpg"
    },
    {
        id: 168,
        artist: "King Crimson",
        album: "In the Court of the Crimson King",
        year: "1969",
        cover: "https://www.listchallenges.com/f/items/a8254a6e-5b05-408d-b4a2-c82d66c17bbe.jpg"
    },
    {
        id: 169,
        artist: "Leonard Cohen",
        album: "Songs From a Room",
        year: "1969",
        cover: "None"
    },
    {
        id: 170,
        artist: "Fairport Convention",
        album: "Liege & Lief",
        year: "None",
        cover: "None"
    },
    {
        id: 171,
        artist: "Scott Walker",
        album: "Scott4",
        year: "None",
        cover: "None"
    },
    {
        id: 172,
        artist: "The Stooges",
        album: "The Stooges",
        year: "1969",
        cover: "None"
    },
    {
        id: 173,
        artist: "Alexander Spence",
        album: "Oar",
        year: "None",
        cover: "None"
    },
    {
        id: 174,
        artist: "Creedence Clearwater Revival",
        album: "Cosmo's Factory",
        year: "1970",
        cover: "None"
    },
    {
        id: 175,
        artist: "Frank Zappa",
        album: "Hot Rats",
        year: "None",
        cover: "None"
    },
    {
        id: 176,
        artist: "Derek and the Dominos",
        album: "Layla & Other Assorted Love Songs",
        year: "None",
        cover: "None"
    },
    {
        id: 177,
        artist: "Miles Davis",
        album: "Bitches Brew",
        year: "1970",
        cover: "None"
    },
    {
        id: 178,
        artist: "Spirit",
        album: "Twelve Dreams of Dr. Sardonicus",
        year: "None",
        cover: "None"
    },
    {
        id: 179,
        artist: "Black Sabbath",
        album: "Black Sabbath (2014 Remaster)",
        year: "1970",
        cover: "None"
    },
    {
        id: 180,
        artist: "The Doors",
        album: "Morrison Hotel",
        year: "None",
        cover: "None"
    },
    {
        id: 181,
        artist: "Carpenters",
        album: "Close to You",
        year: "1970",
        cover: "None"
    },
    {
        id: 182,
        artist: "Stephen Stills",
        album: "Stephen Stills",
        year: "None",
        cover: "None"
    },
    {
        id: 183,
        artist: "John Lennon",
        album: "John Lennon & Plastic Ono Band",
        year: "None",
        cover: "None"
    },
    {
        id: 184,
        artist: "Crosby, Stills, Nash & Young",
        album: "Deja Vu",
        year: "1970",
        cover: "None"
    },
    {
        id: 185,
        artist: "Black Sabbath",
        album: "Paranoid",
        year: "None",
        cover: "None"
    },
    {
        id: 186,
        artist: "Neil Young",
        album: "After the Gold Rush",
        year: "1970",
        cover: "None"
    },
    {
        id: 187,
        artist: "Led Zeppelin",
        album: "Led Zeppelin III",
        year: "None",
        cover: "None"
    },
    {
        id: 188,
        artist: "Deep Purple",
        album: "Deep Purple in Rock",
        year: "None",
        cover: "None"
    },
    {
        id: 189,
        artist: "Van Morrison",
        album: "Moondance",
        year: "None",
        cover: "None"
    },
    {
        id: 190,
        artist: "Grateful Dead",
        album: "American Beauty",
        year: "None",
        cover: "None"
    },
    {
        id: 191,
        artist: "Nick Drake",
        album: "Bryter Layter",
        year: "1970",
        cover: "None"
    },
    {
        id: 192,
        artist: "The Who",
        album: "Live at Leeds",
        year: "1970",
        cover: "None"
    },
    {
        id: 193,
        artist: "Ananda Shankar",
        album: "Ananda Shankar",
        year: "1970",
        cover: "None"
    },
    {
        id: 194,
        artist: "Soft Machine",
        album: "Third",
        year: "None",
        cover: "None"
    },
    {
        id: 195,
        artist: "Rod Stewart",
        album: "Gasoline Alley",
        year: "1970",
        cover: "None"
    },
    {
        id: 196,
        artist: "George Harrison",
        album: "All Things Must Pass",
        year: "None",
        cover: "None"
    },
    {
        id: 197,
        artist: "Simon & Garfunkel",
        album: "Bridge Over Troubled Water",
        year: "None",
        cover: "None"
    },
    {
        id: 198,
        artist: "Cat Stevens",
        album: "Tea for the Tillerman",
        year: "1970",
        cover: "None"
    },
    {
        id: 199,
        artist: "Traffic",
        album: "John Barleycorn Must Die",
        year: "None",
        cover: "None"
    },
    {
        id: 200,
        artist: "The Stooges",
        album: "Fun House",
        year: "None",
        cover: "None"
    },
    {
        id: 201,
        artist: "James Taylor",
        album: "Sweet Baby James",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/aaf45549-2e06-4c72-9d09-44d4ca952d5c.jpg"
    },
    {
        id: 202,
        artist: "Paul McCartney",
        album: "McCartney",
        year: "1970",
        cover: "https://www.listchallenges.com/f/items/847e1456-bc2d-4a17-911d-85282d5fad11.jpg"
    },
    {
        id: 203,
        artist: "Santana",
        album: "Abraxas",
        year: "1970",
        cover: "https://www.listchallenges.com/f/items/52cf5b23-efee-41b4-8722-c1a3ce0b73e3.jpg"
    },
    {
        id: 204,
        artist: "Syd Barrett",
        album: "The Madcap Laughs",
        year: "1970",
        cover: "https://www.listchallenges.com/f/items/64d8f3c2-c222-4ed3-9c2b-358781df7a15.jpg"
    },
    {
        id: 205,
        artist: "Jethro Tull",
        album: "Aqualung",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/76456792-9077-43a3-a837-dbad6f94c37e.jpg"
    },
    {
        id: 206,
        artist: "David Crosby",
        album: "If I Could Only Remember My Name",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/025a50a8-71ba-4493-90c3-435561b0003c.jpg"
    },
    {
        id: 207,
        artist: "Sly & the Family Stone",
        album: "There's a Riot Goin' on",
        year: "1971",
        cover: "https://www.listchallenges.com/f/items/bca19bf7-cd9d-44b5-896e-f6f510d8ef1d.jpg"
    },
    {
        id: 208,
        artist: "Marvin Gaye",
        album: "What's Going On",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/98f24de5-5495-4be4-bf2e-61cb6ec40476.jpg"
    },
    {
        id: 209,
        artist: "Bee Gees",
        album: "Trafalgar",
        year: "1971",
        cover: "None"
    },
    {
        id: 210,
        artist: "The Yes Album",
        album: "Yes",
        year: "None",
        cover: "None"
    },
    {
        id: 211,
        artist: "The Who",
        album: "Who's Next",
        year: "1971",
        cover: "None"
    },
    {
        id: 212,
        artist: "Carole King",
        album: "Tapestry",
        year: "None",
        cover: "None"
    },
    {
        id: 213,
        artist: "Isaac Hayes",
        album: "Shaft: Music From the Soundtrack",
        year: "None",
        cover: "None"
    },
    {
        id: 214,
        artist: "The Allman Brothers Band",
        album: "At Fillmore East",
        year: "1971",
        cover: "None"
    },
    {
        id: 215,
        artist: "The Rolling Stones",
        album: "Sticky Fingers",
        year: "1971",
        cover: "None"
    },
    {
        id: 216,
        artist: "John Lennon",
        album: "Imagine",
        year: "None",
        cover: "None"
    },
    {
        id: 217,
        artist: "The Beach Boys",
        album: "Surf's Up",
        year: "1971",
        cover: "None"
    },
    {
        id: 218,
        artist: "Yes",
        album: "Fragile",
        year: "1970",
        cover: "None"
    },
    {
        id: 219,
        artist: "The Doors",
        album: "L.A. Woman",
        year: "None",
        cover: "None"
    },
    {
        id: 220,
        artist: "Can",
        album: "Tago Mago",
        year: "1971",
        cover: "None"
    },
    {
        id: 221,
        artist: "Elton John",
        album: "Madman Across the Water",
        year: "1971",
        cover: "None"
    },
    {
        id: 222,
        artist: "Dolly Parton",
        album: "Coat of Many Colors",
        year: "1971",
        cover: "None"
    },
    {
        id: 223,
        artist: "Don Mclean",
        album: "American Pie",
        year: "1971",
        cover: "None"
    },
    {
        id: 224,
        artist: "Emerson, Lake & Palmer",
        album: "Tarkus",
        year: "None",
        cover: "None"
    },
    {
        id: 225,
        artist: "Led Zeppelin",
        album: "Led Zeppelin IV",
        year: "1971",
        cover: "None"
    },
    {
        id: 226,
        artist: "Serge Gainsbourg",
        album: "Histoire De Melody Nelson",
        year: "None",
        cover: "None"
    },
    {
        id: 227,
        artist: "Rod Stewart",
        album: "Every Picture Tells a Story",
        year: "None",
        cover: "None"
    },
    {
        id: 228,
        artist: "Emerson, Lake & Palmer",
        album: "Pictures at an Exhibition",
        year: "1972",
        cover: "None"
    },
    {
        id: 229,
        artist: "Leonard Cohen",
        album: "Songs of Love and Hate",
        year: "None",
        cover: "None"
    },
    {
        id: 230,
        artist: "Joni Mitchell",
        album: "Blue",
        year: "1971",
        cover: "None"
    },
    {
        id: 231,
        artist: "Janis Joplin",
        album: "Pearl",
        year: "None",
        cover: "None"
    },
    {
        id: 232,
        artist: "Funkadelic",
        album: "Maggot Brain",
        year: "None",
        cover: "None"
    },
    {
        id: 233,
        artist: "Fela Ransome-Kuti & the Afrika 70 With Ginger Baker",
        album: "Live!",
        year: "None",
        cover: "None"
    },
    {
        id: 234,
        artist: "The Faces",
        album: "A Nod Is as Good as a Wink... to a Blind Horse",
        year: "None",
        cover: "None"
    },
    {
        id: 235,
        artist: "Flamin' Groovies",
        album: "Teenage Head",
        year: "None",
        cover: "None"
    },
    {
        id: 236,
        artist: "Gene Clark",
        album: "White Light",
        year: "1971",
        cover: "None"
    },
    {
        id: 237,
        artist: "John Prine",
        album: "John Prine",
        year: "None",
        cover: "None"
    },
    {
        id: 238,
        artist: "Harry Nilsson",
        album: "Nilsson Schmilsson",
        year: "None",
        cover: "None"
    },
    {
        id: 239,
        artist: "T. Rex",
        album: "Electric Warrior",
        year: "None",
        cover: "None"
    },
    {
        id: 240,
        artist: "David Bowie",
        album: "Hunky Dory",
        year: "1971",
        cover: "None"
    },
    {
        id: 241,
        artist: "Randy Newman",
        album: "Sail Away",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/1ed76328-5282-4b4c-968b-5c3e0767c1f5.jpg"
    },
    {
        id: 242,
        artist: "Deep Purple",
        album: "Machine Head",
        year: "1972",
        cover: "https://www.listchallenges.com/f/items/5db06f46-d41a-4aa8-bd8e-0860a4be476f.jpg"
    },
    {
        id: 243,
        artist: "Big Star",
        album: "#1 Record",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/062c5370-3f37-4888-ba0d-00976e81bedf.jpg"
    },
    {
        id: 244,
        artist: "Black Sabbath",
        album: "Vol. 4",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/ac667a6f-9f8a-4e54-bbc7-3618271623c8.jpg"
    },
    {
        id: 245,
        artist: "Steely Dan",
        album: "Can't Buy a Thrill",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/c9009dbb-9b86-4de8-8806-12c2654b63aa.jpg"
    },
    {
        id: 246,
        artist: "Neil Young",
        album: "Harvest",
        year: "1972",
        cover: "https://www.listchallenges.com/f/items/17cb6d78-1975-4a94-a8e0-5f0b87121072.jpg"
    },
    {
        id: 247,
        artist: "Curtis Mayfield",
        album: "Superfly",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/a4725ac4-bc5e-4ca7-b661-13abd2336501.jpg"
    },
    {
        id: 248,
        artist: "Slade",
        album: "Slayed",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/4660fb12-0889-473c-ab72-87d6901f561e.jpg"
    },
    {
        id: 249,
        artist: "Deep Purple",
        album: "Made in Japan",
        year: "None",
        cover: "None"
    },
    {
        id: 250,
        artist: "Lou Reed",
        album: "Transformer",
        year: "1972",
        cover: "None"
    },
    {
        id: 251,
        artist: "Yes",
        album: "Close to the Edge",
        year: "1972",
        cover: "None"
    },
    {
        id: 252,
        artist: "Milton Nascimento E Lô Borges",
        album: "Clube Da Esquina",
        year: "None",
        cover: "None"
    },
    {
        id: 253,
        artist: "Hugh Masekela",
        album: "Home Is Where the Music Is",
        year: "1972",
        cover: "None"
    },
    {
        id: 254,
        artist: "Todd Rundgren",
        album: "Something/Anything?",
        year: "None",
        cover: "None"
    },
    {
        id: 255,
        artist: "Nitty Gritty Dirt Band",
        album: "Will the Circle Be Unbroken",
        year: "1972",
        cover: "None"
    },
    {
        id: 256,
        artist: "Stevie Wonder",
        album: "Talking Book",
        year: "None",
        cover: "None"
    },
    {
        id: 257,
        artist: "Manassas",
        album: "Manassas",
        year: "1972",
        cover: "None"
    },
    {
        id: 258,
        artist: "T. Rex",
        album: "The Slider",
        year: "1972",
        cover: "None"
    },
    {
        id: 259,
        artist: "David Ackles",
        album: "American Gothic",
        year: "1972",
        cover: "None"
    },
    {
        id: 260,
        artist: "Tim Buckley",
        album: "Greetings From LA",
        year: "None",
        cover: "None"
    },
    {
        id: 261,
        artist: "Nick Drake",
        album: "Pink Moon",
        year: "None",
        cover: "None"
    },
    {
        id: 262,
        artist: "Eagles",
        album: "Eagles",
        year: "None",
        cover: "None"
    },
    {
        id: 263,
        artist: "Paul Simon",
        album: "Paul Simon",
        year: "None",
        cover: "None"
    },
    {
        id: 264,
        artist: "Roxy Music",
        album: "Roxy Music",
        year: "1972",
        cover: "None"
    },
    {
        id: 265,
        artist: "Alice Cooper",
        album: "School's Out",
        year: "None",
        cover: "None"
    },
    {
        id: 266,
        artist: "The Temptations",
        album: "All Directions",
        year: "1972",
        cover: "None"
    },
    {
        id: 267,
        artist: "David Bowie",
        album: "The Rise and Fall of Ziggy Stardust & the Spiders From Mars",
        year: "None",
        cover: "None"
    },
    {
        id: 268,
        artist: "War",
        album: "The World Is a Ghetto",
        year: "None",
        cover: "None"
    },
    {
        id: 269,
        artist: "Al Green",
        album: "Let's Stay Together",
        year: "None",
        cover: "None"
    },
    {
        id: 270,
        artist: "The Rolling Stones",
        album: "Exile on Main Street",
        year: "None",
        cover: "None"
    },
    {
        id: 271,
        artist: "Lynyrd Skynyrd",
        album: "Lynyrd Skynyrd (Pronounced 'Lĕh-'Nérd 'Skin-'Nérd)",
        year: "None",
        cover: "None"
    },
    {
        id: 272,
        artist: "The Incredible Bongo Band",
        album: "Bongo Rock",
        year: "1973",
        cover: "None"
    },
    {
        id: 273,
        artist: "David Bowie",
        album: "Aladdin Sane",
        year: "1973",
        cover: "None"
    },
    {
        id: 274,
        artist: "King Crimson",
        album: "Larks' Tongues in Aspic",
        year: "1973",
        cover: "None"
    },
    {
        id: 275,
        artist: "Bob Marley and the Wailers",
        album: "Catch a Fire",
        year: "None",
        cover: "None"
    },
    {
        id: 276,
        artist: "Hawkwind",
        album: "Space Ritual",
        year: "1973",
        cover: "None"
    },
    {
        id: 277,
        artist: "John Cale",
        album: "Paris ",
        year: "1919",
        cover: "None"
    },
    {
        id: 278,
        artist: "CAN",
        album: "Future Days",
        year: "1973",
        cover: "None"
    },
    {
        id: 279,
        artist: "Lou Reed",
        album: "Berlin",
        year: "1973",
        cover: "None"
    },
    {
        id: 280,
        artist: "Genesis",
        album: "Selling England by the Pound",
        year: "1973",
        cover: "None"
    },
    {
        id: 281,
        artist: "Marvin Gaye",
        album: "Let's Get It On",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/491133b2-5ff7-48f5-8835-a9132e107197.jpg"
    },
    {
        id: 282,
        artist: "John Martyn",
        album: "Solid Air",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/164b99c6-1f5f-40df-8821-e70c32420aa0.jpg"
    },
    {
        id: 283,
        artist: "Roxy Music",
        album: "For Your Pleasure",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/e0cddf50-5075-4f49-93ed-bd154d703343.jpg"
    },
    {
        id: 284,
        artist: "Faust",
        album: "Faust IV",
        year: "1973",
        cover: "https://www.listchallenges.com/f/items/7546c4f9-d9a5-4b08-9899-e0a68363a4bc.jpg"
    },
    {
        id: 285,
        artist: "Herbie Hancock",
        album: "Headhunters",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/98db9da2-0a59-47c3-9820-a81742a9ab21.jpg"
    },
    {
        id: 286,
        artist: "Mott the Hoople",
        album: "Mott",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/2e7bc22b-7717-4326-9cb9-176d00a58b64.jpg"
    },
    {
        id: 287,
        artist: "Mike Oldfield",
        album: "Tubular Bells",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/769f9349-d531-4b0d-9ce3-713c9be7ffb1.jpg"
    },
    {
        id: 288,
        artist: "Todd Rundgren",
        album: "A Wizard / a True Star",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/5acf4556-9d98-4c66-a031-10cd0cbea589.jpg"
    },
    {
        id: 289,
        artist: "Elton John",
        album: "Goodbye Yellow Brick Road",
        year: "1973",
        cover: "None"
    },
    {
        id: 290,
        artist: "Steely Dan",
        album: "Countdown to Ecstasy",
        year: "None",
        cover: "None"
    },
    {
        id: 291,
        artist: "Waylon Jennings",
        album: "Honky Tonk Heroes",
        year: "1973",
        cover: "None"
    },
    {
        id: 292,
        artist: "Pink Floyd",
        album: "The Dark Side of the Moon",
        year: "1973",
        cover: "None"
    },
    {
        id: 293,
        artist: "Stevie Wonder",
        album: "Innervisions",
        year: "None",
        cover: "None"
    },
    {
        id: 294,
        artist: "ZZ Top",
        album: "Tres Hombres",
        year: "None",
        cover: "None"
    },
    {
        id: 295,
        artist: "Paul McCartney and Wings",
        album: "Band on the Run",
        year: "1973",
        cover: "None"
    },
    {
        id: 296,
        artist: "The Sensational Alex Harvey Band",
        album: "Next",
        year: "1973",
        cover: "None"
    },
    {
        id: 297,
        artist: "Alice Cooper",
        album: "Billion Dollar Babies",
        year: "None",
        cover: "None"
    },
    {
        id: 298,
        artist: "The Stooges",
        album: "Raw Power (50th Anniversary Legacy Edition)",
        year: "1973",
        cover: "None"
    },
    {
        id: 299,
        artist: "Isley Brothers",
        album: "3+3",
        year: "None",
        cover: "None"
    },
    {
        id: 300,
        artist: "New York Dolls",
        album: "New York Dolls",
        year: "None",
        cover: "None"
    },
    {
        id: 301,
        artist: "Bad Company",
        album: "Bad Company",
        year: "None",
        cover: "None"
    },
    {
        id: 302,
        artist: "Brian Eno",
        album: "Here Come the Warm Jets",
        year: "1973",
        cover: "None"
    },
    {
        id: 303,
        artist: "Genesis",
        album: "The Lamb Lies Down on Broadway",
        year: "1974",
        cover: "None"
    },
    {
        id: 304,
        artist: "Shuggie Otis",
        album: "Inspiration Information",
        year: "1974",
        cover: "None"
    },
    {
        id: 305,
        artist: "Stevie Wonder",
        album: "Fulfillingness First Finale",
        year: "None",
        cover: "None"
    },
    {
        id: 306,
        artist: "Eric Clapton",
        album: "461 Ocean Boulevard",
        year: "None",
        cover: "None"
    },
    {
        id: 307,
        artist: "Kraftwerk",
        album: "Autobahn",
        year: "None",
        cover: "None"
    },
    {
        id: 308,
        artist: "Van Morrison",
        album: "It's Too Late to Stop Now",
        year: "1974",
        cover: "None"
    },
    {
        id: 309,
        artist: "Joni Mitchell",
        album: "Court and Spark",
        year: "1974",
        cover: "None"
    },
    {
        id: 310,
        artist: "Queen",
        album: "Queen II",
        year: "1974",
        cover: "None"
    },
    {
        id: 311,
        artist: "Roxy Music",
        album: "Country Life",
        year: "None",
        cover: "None"
    },
    {
        id: 312,
        artist: "Tangerine Dream",
        album: "Phaedra",
        year: "None",
        cover: "None"
    },
    {
        id: 313,
        artist: "Sparks",
        album: "Kimono My House",
        year: "1974",
        cover: "None"
    },
    {
        id: 314,
        artist: "Supertramp",
        album: "Crime of the Century",
        year: "None",
        cover: "None"
    },
    {
        id: 315,
        artist: "Richard and Linda Thompson",
        album: "I Want to See the Bright Lights Tonight",
        year: "None",
        cover: "None"
    },
    {
        id: 316,
        artist: "Gil Scott-Heron",
        album: "Winter in America",
        year: "None",
        cover: "None"
    },
    {
        id: 317,
        artist: "Queen",
        album: "Sheer Heart Attack",
        year: "None",
        cover: "None"
    },
    {
        id: 318,
        artist: "10cc",
        album: "Sheet Music",
        year: "None",
        cover: "None"
    },
    {
        id: 319,
        artist: "Neil Young",
        album: "On the Beach",
        year: "None",
        cover: "None"
    },
    {
        id: 320,
        artist: "George Jones",
        album: "The Grand Tour",
        year: "1974",
        cover: "None"
    },
    {
        id: 321,
        artist: "Gene Clark",
        album: "No Other",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/0982ec3c-4af9-42a6-a0de-b6a113f7d93b.jpg"
    },
    {
        id: 322,
        artist: "Steely Dan",
        album: "Pretzel Logic",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/fc58684c-3ad9-4e11-a476-a6e57d5d984b.jpg"
    },
    {
        id: 323,
        artist: "Randy Newman",
        album: "Good Old Boys",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/db43fb10-9a60-4242-927a-0d813e75d111.jpg"
    },
    {
        id: 324,
        artist: "Bob Marley and the Wailers",
        album: "Natty Dread",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/6230e100-adb1-49f9-a9e6-9fa5b70ff7ad.jpg"
    },
    {
        id: 325,
        artist: "Robert Wyatt",
        album: "Rock Bottom",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/c0227d08-1655-4b82-9812-87512b691810.jpg"
    },
    {
        id: 326,
        artist: "Gram Parsons",
        album: "Grievous Angel",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/ff2cb1e1-1e5d-4d4a-87e5-7f9a31a5f7ef.jpg"
    },
    {
        id: 327,
        artist: "The Dictators",
        album: "Go Girl Crazy!",
        year: "1975",
        cover: "https://www.listchallenges.com/f/items/ed6ea787-2cb1-48c1-be93-597cf2558b64.jpg"
    },
    {
        id: 328,
        artist: "Brian Eno",
        album: "Another Green World",
        year: "1975",
        cover: "https://www.listchallenges.com/f/items/b29092ff-cf06-45b4-94da-18ae3c976c7e.jpg"
    },
    {
        id: 329,
        artist: "NEU!",
        album: "Neu! '75",
        year: "1975",
        cover: "None"
    },
    {
        id: 330,
        artist: "Led Zeppelin",
        album: "Physical Graffiti",
        year: "None",
        cover: "None"
    },
    {
        id: 331,
        artist: "Keith Jarrett",
        album: "The Köln Concert",
        year: "None",
        cover: "None"
    },
    {
        id: 332,
        artist: "Aerosmith",
        album: "Toys in the Attic",
        year: "None",
        cover: "None"
    },
    {
        id: 333,
        artist: "David Bowie",
        album: "Young Americans",
        year: "None",
        cover: "None"
    },
    {
        id: 334,
        artist: "Burning Spear",
        album: "Marcus Garvey",
        year: "None",
        cover: "None"
    },
    {
        id: 335,
        artist: "Bruce Springsteen",
        album: "Born to Run",
        year: "1975",
        cover: "None"
    },
    {
        id: 336,
        artist: "Emmylou Harris",
        album: "Pieces of the Sky",
        year: "None",
        cover: "None"
    },
    {
        id: 337,
        artist: "Dion",
        album: "Born to Be With You",
        year: "1975",
        cover: "None"
    },
    {
        id: 338,
        artist: "Joni Mitchell",
        album: "The Hissing of Summer Lawns",
        year: "None",
        cover: "None"
    },
    {
        id: 339,
        artist: "Tom Waits",
        album: "Nighthawks at the Diner",
        year: "1975",
        cover: "None"
    },
    {
        id: 340,
        artist: "Rahul Dev Burman",
        album: "Shalimar",
        year: "1978",
        cover: "None"
    },
    {
        id: 341,
        artist: "Neil Young",
        album: "Tonight's the Night",
        year: "1975",
        cover: "None"
    },
    {
        id: 342,
        artist: "Bob Dylan",
        album: "Blood on the Tracks",
        year: "None",
        cover: "None"
    },
    {
        id: 343,
        artist: "Pink Floyd",
        album: "Wish You Were Here",
        year: "1975",
        cover: "None"
    },
    {
        id: 344,
        artist: "Patti Smith",
        album: "Horses",
        year: "1975",
        cover: "None"
    },
    {
        id: 345,
        artist: "Queen",
        album: "A Night at the Opera",
        year: "None",
        cover: "None"
    },
    {
        id: 346,
        artist: "Willie Nelson",
        album: "Red Headed Stranger",
        year: "None",
        cover: "None"
    },
    {
        id: 347,
        artist: "Earth, Wind & Fire",
        album: "That's the Way of the World",
        year: "None",
        cover: "None"
    },
    {
        id: 348,
        artist: "Curtis Mayfield",
        album: "There's No Place Like America Today",
        year: "None",
        cover: "None"
    },
    {
        id: 349,
        artist: "Tom Petty and the Heartbreakers",
        album: "Tom Petty and the Heartbreakers",
        year: "None",
        cover: "None"
    },
    {
        id: 350,
        artist: "The Modern Lovers",
        album: "The Modern Lovers",
        year: "None",
        cover: "None"
    },
    {
        id: 351,
        artist: "David Bowie",
        album: "Station to Station",
        year: "1976",
        cover: "None"
    },
    {
        id: 352,
        artist: "Joni Mitchell",
        album: "Hejira",
        year: "None",
        cover: "None"
    },
    {
        id: 353,
        artist: "Boston",
        album: "Boston",
        year: "None",
        cover: "None"
    },
    {
        id: 354,
        artist: "Eagles",
        album: "Hotel California",
        year: "None",
        cover: "None"
    },
    {
        id: 355,
        artist: "ABBA",
        album: "Arrival",
        year: "None",
        cover: "None"
    },
    {
        id: 356,
        artist: "Kiss",
        album: "Destroyer",
        year: "None",
        cover: "None"
    },
    {
        id: 357,
        artist: "Rush",
        album: "2112",
        year: "1976",
        cover: "None"
    },
    {
        id: 358,
        artist: "Jorge Ben Jor",
        album: "África Brasil",
        year: "None",
        cover: "None"
    },
    {
        id: 359,
        artist: "Joan Armatrading",
        album: "Joan Armatrading",
        year: "1976",
        cover: "None"
    },
    {
        id: 360,
        artist: "Aerosmith",
        album: "Rocks",
        year: "None",
        cover: "None"
    },
    {
        id: 361,
        artist: "Parliament",
        album: "Mothership Connection",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/d61967f7-df9c-4f32-8e57-c5213788fdd5.jpg"
    },
    {
        id: 362,
        artist: "Penguin Cafe Orchestra",
        album: "Music From the Penguin Café",
        year: "1976",
        cover: "https://www.listchallenges.com/f/items/7b3b5ca3-b6a3-43a3-a0fd-3cb41e7972b2.jpg"
    },
    {
        id: 363,
        artist: "Jean-Michelle Jarre",
        album: "Oxygene",
        year: "1976",
        cover: "https://www.listchallenges.com/f/items/496488fd-ecb0-441e-995a-0db759145ffd.jpg"
    },
    {
        id: 364,
        artist: "Ramones",
        album: "Ramones",
        year: "1976",
        cover: "https://www.listchallenges.com/f/items/963c8275-02ce-4159-8c32-810478952471.jpg"
    },
    {
        id: 365,
        artist: "Peter Tosh",
        album: "Legalize It",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/79d75ff9-e340-47d3-8f5e-e9518383418c.jpg"
    },
    {
        id: 366,
        artist: "Fela Kuti & Afrika 70",
        album: "Zombie",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/59df6775-f99a-486d-9c6d-5722ab63f773.jpg"
    },
    {
        id: 367,
        artist: "Stevie Wonder",
        album: "Songs in the Key of Life",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/c41d168c-0373-498a-8a7e-15a1e3a60de6.jpg"
    },
    {
        id: 368,
        artist: "Peter Frampton",
        album: "Frampton Comes Alive!",
        year: "1976",
        cover: "https://www.listchallenges.com/f/items/e38cd905-a108-43ad-bca8-2b786e59d660.jpg"
    },
    {
        id: 369,
        artist: "Brian Eno",
        album: "Before and After Science",
        year: "1977",
        cover: "None"
    },
    {
        id: 370,
        artist: "Kraftwerk",
        album: "Trans-Europe Express",
        year: "1977",
        cover: "None"
    },
    {
        id: 371,
        artist: "Billy Joel",
        album: "The Stranger",
        year: "None",
        cover: "None"
    },
    {
        id: 372,
        artist: "Bob Marley and the Wailers",
        album: "Exodus",
        year: "None",
        cover: "None"
    },
    {
        id: 373,
        artist: "Electric Light Orchestra",
        album: "Out of the Blue",
        year: "None",
        cover: "None"
    },
    {
        id: 374,
        artist: "Weather Report",
        album: "Heavy Weather",
        year: "1977",
        cover: "None"
    },
    {
        id: 375,
        artist: "Muddy Waters",
        album: "Hard Again",
        year: "1977",
        cover: "None"
    },
    {
        id: 376,
        artist: "The Stranglers",
        album: "Rattus Norvegicus",
        year: "None",
        cover: "None"
    },
    {
        id: 377,
        artist: "The Clash",
        album: "The Clash",
        year: "None",
        cover: "None"
    },
    {
        id: 378,
        artist: "David Bowie",
        album: "Low",
        year: "None",
        cover: "None"
    },
    {
        id: 379,
        artist: "Steely Dan",
        album: "Aja",
        year: "None",
        cover: "None"
    },
    {
        id: 380,
        artist: "Wire",
        album: "Pink Flag",
        year: "None",
        cover: "None"
    },
    {
        id: 381,
        artist: "John Martyn",
        album: "One World",
        year: "None",
        cover: "None"
    },
    {
        id: 382,
        artist: "Talking Heads",
        album: "Talking Heads: 77",
        year: "None",
        cover: "None"
    },
    {
        id: 383,
        artist: "Fleetwood Mac",
        album: "Rumours",
        year: "None",
        cover: "None"
    },
    {
        id: 384,
        artist: "David Bowie",
        album: "Heroes",
        year: "None",
        cover: "None"
    },
    {
        id: 385,
        artist: "Dennis Wilson",
        album: "Pacific Ocean Blue",
        year: "1977",
        cover: "None"
    },
    {
        id: 386,
        artist: "Suicide",
        album: "Suicide",
        year: "None",
        cover: "None"
    },
    {
        id: 387,
        artist: "Iggy Pop",
        album: "The Idiot",
        year: "1977",
        cover: "None"
    },
    {
        id: 388,
        artist: "Peter Gabriel",
        album: "Peter Gabriel 1: Car (Remastered)",
        year: "None",
        cover: "None"
    },
    {
        id: 389,
        artist: "Meat Loaf",
        album: "Bat Out of Hell",
        year: "None",
        cover: "None"
    },
    {
        id: 390,
        artist: "Television",
        album: "Marquee Moon",
        year: "1977",
        cover: "None"
    },
    {
        id: 391,
        artist: "Elvis Costello",
        album: "My Aim Is True",
        year: "None",
        cover: "None"
    },
    {
        id: 392,
        artist: "Iggy Pop",
        album: "Lust for Life",
        year: "1977",
        cover: "None"
    },
    {
        id: 393,
        artist: "Ian Dury",
        album: "New Boots and Panties!!",
        year: "None",
        cover: "None"
    },
    {
        id: 394,
        artist: "Sex Pistols",
        album: "Never Mind the Bollocks Here's the Sex Pistols",
        year: "None",
        cover: "None"
    },
    {
        id: 395,
        artist: "Pere Ubu",
        album: "The Modern Dance",
        year: "None",
        cover: "None"
    },
    {
        id: 396,
        artist: "Kraftwerk",
        album: "The Man-Machine",
        year: "None",
        cover: "None"
    },
    {
        id: 397,
        artist: "Blondie",
        album: "Parallel Lines",
        year: "None",
        cover: "None"
    },
    {
        id: 398,
        artist: "Elis Regina",
        album: "Vento De Maio",
        year: "1985",
        cover: "None"
    },
    {
        id: 399,
        artist: "Pere Ubu",
        album: "Dub Housing",
        year: "1978",
        cover: "None"
    },
    {
        id: 400,
        artist: "The Only Ones",
        album: "The Only Ones",
        year: "1978",
        cover: "None"
    },
    {
        id: 401,
        artist: "Elvis Costello",
        album: "This Year's Model",
        year: "1978",
        cover: "https://www.listchallenges.com/f/items/31532865-98e2-496c-8bef-d105a147d0a3.jpg"
    },
    {
        id: 402,
        artist: "The Jam",
        album: "All Mod Cons",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/ae0fac9c-6b91-4f21-be86-f0dc49eee972.jpg"
    },
    {
        id: 403,
        artist: "Joe Ely",
        album: "Honky Tonk Masquerade",
        year: "1978",
        cover: "https://www.listchallenges.com/f/items/b1ab3c5f-f7ec-448b-aa2c-151952414bf3.jpg"
    },
    {
        id: 404,
        artist: "The Adverts",
        album: "Crossing the Red Sea With the Adverts",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/4aff3447-bdae-4cda-8427-a5f1895d88d3.jpg"
    },
    {
        id: 405,
        artist: "Big Star",
        album: "Third / Sister Lovers",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/c0418aa0-eaad-4fd6-9859-55b17b3ff2f4.jpg"
    },
    {
        id: 406,
        artist: "The Residents",
        album: "Duck Stab/Buster & Glen",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/bffdb7ae-2195-4ae5-b998-4fb1fc442e44.jpg"
    },
    {
        id: 407,
        artist: "Public Image Limited",
        album: "Public Image Limited",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/4cd3ab44-c8b6-4067-81c9-c414b88486eb.jpg"
    },
    {
        id: 408,
        artist: "Magazine",
        album: "Real Life",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/a200c37a-4240-4d6b-9a2f-f8c81fc6a889.jpg"
    },
    {
        id: 409,
        artist: "Bruce Springsteen",
        album: "Darkness on the Edge of Town",
        year: "None",
        cover: "None"
    },
    {
        id: 410,
        artist: "Funkadelic",
        album: "One Nation Under a Groove",
        year: "None",
        cover: "None"
    },
    {
        id: 411,
        artist: "Throbbing Gristle",
        album: "D.O.A. Third and Final Report",
        year: "None",
        cover: "None"
    },
    {
        id: 412,
        artist: "Thin Lizzy",
        album: "Live and Dangerous",
        year: "None",
        cover: "None"
    },
    {
        id: 413,
        artist: "Talking Heads",
        album: "More Songs About Buildings and Food",
        year: "None",
        cover: "None"
    },
    {
        id: 414,
        artist: "Buzzcocks",
        album: "Another Music in a Different Kitchen",
        year: "None",
        cover: "None"
    },
    {
        id: 415,
        artist: "Van Halen",
        album: "Van Halen (Remastered)",
        year: "None",
        cover: "None"
    },
    {
        id: 416,
        artist: "Willie Colón & Rubén Blades",
        album: "Siembra",
        year: "1978",
        cover: "None"
    },
    {
        id: 417,
        artist: "The Cars",
        album: "The Cars",
        year: "1979",
        cover: "None"
    },
    {
        id: 418,
        artist: "Devo",
        album: "Q: Are We Not Men? A: We Are Devo!",
        year: "1978",
        cover: "None"
    },
    {
        id: 419,
        artist: "Dire Straits",
        album: "Dire Straits",
        year: "1978",
        cover: "None"
    },
    {
        id: 420,
        artist: "The Saints",
        album: "Eternally Yours",
        year: "1978",
        cover: "None"
    },
    {
        id: 421,
        artist: "Marvin Gaye",
        album: " Here, My Dear",
        year: "None",
        cover: "None"
    },
    {
        id: 422,
        artist: "Willie Nelson",
        album: "Stardust",
        year: "None",
        cover: "None"
    },
    {
        id: 423,
        artist: "Chic",
        album: "C'est Chic",
        year: "None",
        cover: "None"
    },
    {
        id: 424,
        artist: "X-Ray Spex",
        album: "Germ-Free Adolescents",
        year: "1978",
        cover: "None"
    },
    {
        id: 425,
        artist: "Brian Eno",
        album: "Ambient 1: Music for Airports",
        year: "1978",
        cover: "None"
    },
    {
        id: 426,
        artist: "Siouxsie & the Banshees",
        album: "The Scream",
        year: "None",
        cover: "None"
    },
    {
        id: 427,
        artist: "AC/DC",
        album: "Highway to Hell",
        year: "None",
        cover: "None"
    },
    {
        id: 428,
        artist: "Sister Sledge",
        album: "We Are Family",
        year: "None",
        cover: "None"
    },
    {
        id: 429,
        artist: "The Crusaders",
        album: "Street Life",
        year: "1979",
        cover: "None"
    },
    {
        id: 430,
        artist: "Germs",
        album: "GI",
        year: "None",
        cover: "None"
    },
    {
        id: 431,
        artist: "The B-52'S",
        album: "The B-52'S",
        year: "1979",
        cover: "None"
    },
    {
        id: 432,
        artist: "Holger Czukay",
        album: "Movies",
        year: "1979",
        cover: "None"
    },
    {
        id: 433,
        artist: "The Fall",
        album: "Live at the Witch Trials",
        year: "None",
        cover: "None"
    },
    {
        id: 434,
        artist: "The Police",
        album: "Reggatta De Blanc",
        year: "None",
        cover: "None"
    },
    {
        id: 435,
        artist: "Talking Heads",
        album: "Fear of Music",
        year: "1979",
        cover: "None"
    },
    {
        id: 436,
        artist: "Joy Division",
        album: "Unknown Pleasures",
        year: "None",
        cover: "None"
    },
    {
        id: 437,
        artist: "Chic",
        album: "Risque",
        year: "None",
        cover: "None"
    },
    {
        id: 438,
        artist: "Undertones",
        album: "The Undertones",
        year: "None",
        cover: "None"
    },
    {
        id: 439,
        artist: "The Clash",
        album: "London Calling",
        year: "None",
        cover: "None"
    },
    {
        id: 440,
        artist: "Japan",
        album: "Quiet Life",
        year: "None",
        cover: "None"
    },
    {
        id: 441,
        artist: "Marianne Faithfull",
        album: "Broken English",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/3eef8df6-4c83-422d-a781-bbcc269b41f0.jpg"
    },
    {
        id: 442,
        artist: "The Slits",
        album: "Cut",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/22a3f814-3fda-4eb3-8cf6-fe196107adc5.jpg"
    },
    {
        id: 443,
        artist: "Elvis Costello and the Attractions",
        album: "Armed Forces",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/b456b244-0153-4667-9c8b-dc872a0779b8.jpg"
    },
    {
        id: 444,
        artist: "Neil Young and Crazy Horse",
        album: "Rust Never Sleeps",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/bc43045b-faed-44be-b7fc-d0bdeb50ba8e.jpg"
    },
    {
        id: 445,
        artist: "Gang of Four",
        album: "Entertainment!",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/8a4146d6-a869-4f5e-aea9-89768f0b7488.jpg"
    },
    {
        id: 446,
        artist: "Cheap Trick",
        album: "At Budokan",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/5391c5d8-62be-4234-a6e2-f9d3efb741d4.jpg"
    },
    {
        id: 447,
        artist: "Fleetwood Mac",
        album: "Tusk",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/07411098-55fc-4eb2-9343-5e09bce8fa3e.jpg"
    },
    {
        id: 448,
        artist: "Pink Floyd",
        album: "The Wall",
        year: "1979",
        cover: "https://www.listchallenges.com/f/items/0d0087b0-1b7c-4300-afad-78bcb4ac248e.jpg"
    },
    {
        id: 449,
        artist: "Public Image, Ltd.",
        album: "Metal Box",
        year: "None",
        cover: "None"
    },
    {
        id: 450,
        artist: "The Damned",
        album: "Machine Gun Etiquette",
        year: "None",
        cover: "None"
    },
    {
        id: 451,
        artist: "Michael Jackson",
        album: "Off the Wall",
        year: "None",
        cover: "None"
    },
    {
        id: 452,
        artist: "Gary Numan",
        album: "The Pleasure Principle",
        year: "1979",
        cover: "None"
    },
    {
        id: 453,
        artist: "The Specials",
        album: "The Specials",
        year: "None",
        cover: "None"
    },
    {
        id: 454,
        artist: "Adam and the Ants",
        album: "Kings of the Wild Frontier",
        year: "None",
        cover: "None"
    },
    {
        id: 455,
        artist: "Dexy's Midnight Runners",
        album: "Searching for the Young Soul Rebels",
        year: "None",
        cover: "None"
    },
    {
        id: 456,
        artist: "AC/DC",
        album: "Back in Black",
        year: "None",
        cover: "None"
    },
    {
        id: 457,
        artist: "The Cramps",
        album: "The Songs the Lord Taught Us",
        year: "None",
        cover: "None"
    },
    {
        id: 458,
        artist: "Dead Kennedys",
        album: "Fresh Fruit for Rotting Vegetables",
        year: "1980",
        cover: "None"
    },
    {
        id: 459,
        artist: "Peter Gabriel",
        album: "Peter Gabriel 3: Melt (Remastered)",
        year: "1980",
        cover: "None"
    },
    {
        id: 460,
        artist: "The Soft Boys",
        album: "Underwater Moonlight",
        year: "None",
        cover: "None"
    },
    {
        id: 461,
        artist: "The Cure",
        album: "Seventeen Seconds",
        year: "None",
        cover: "None"
    },
    {
        id: 462,
        artist: "Echo & the Bunnymen",
        album: "Crocodiles",
        year: "None",
        cover: "None"
    },
    {
        id: 463,
        artist: "Motörhead",
        album: "Ace of Spades",
        year: "None",
        cover: "None"
    },
    {
        id: 464,
        artist: "Killing Joke",
        album: "Killing Joke",
        year: "None",
        cover: "None"
    },
    {
        id: 465,
        artist: "Judas Priest",
        album: "British Steel",
        year: "None",
        cover: "None"
    },
    {
        id: 466,
        artist: "Circle Jerks",
        album: "Group Sex",
        year: "None",
        cover: "None"
    },
    {
        id: 467,
        artist: "Joy Division",
        album: "Closer",
        year: "None",
        cover: "None"
    },
    {
        id: 468,
        artist: "Talking Heads",
        album: "Remain in Light",
        year: "None",
        cover: "None"
    },
    {
        id: 469,
        artist: "Iron Maiden",
        album: "Iron Maiden",
        year: "None",
        cover: "None"
    },
    {
        id: 470,
        artist: "The Undertones",
        album: "Hypnotised",
        year: "1980",
        cover: "None"
    },
    {
        id: 471,
        artist: "The Jam",
        album: "Sound Affects",
        year: "None",
        cover: "None"
    },
    {
        id: 472,
        artist: "Tom Waits",
        album: "Heartattack and Vine",
        year: "1980",
        cover: "None"
    },
    {
        id: 473,
        artist: "UB40",
        album: "Signing Off",
        year: "None",
        cover: "None"
    },
    {
        id: 474,
        artist: "The Teardrop Explodes",
        album: "Kilimanjaro",
        year: "None",
        cover: "None"
    },
    {
        id: 475,
        artist: "The Specials",
        album: "More Specials",
        year: "1980",
        cover: "None"
    },
    {
        id: 476,
        artist: "Steve Winwood",
        album: "Arc of a Driver",
        year: "1980",
        cover: "None"
    },
    {
        id: 477,
        artist: "Pretenders",
        album: "Pretenders",
        year: "None",
        cover: "None"
    },
    {
        id: 478,
        artist: "Einstürzende Neubauten",
        album: "Kollaps",
        year: "None",
        cover: "None"
    },
    {
        id: 479,
        artist: "Siouxsie and the Banshees",
        album: "Juju",
        year: "None",
        cover: "None"
    },
    {
        id: 480,
        artist: "Heaven 17",
        album: "Penthouse and Pavement",
        year: "1981",
        cover: "None"
    },
    {
        id: 481,
        artist: "Beauty and the Beat",
        album: "The Go Go's",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/79786909-d32e-48cc-9a72-806938d2ffa3.jpg"
    },
    {
        id: 482,
        artist: "Motorhead",
        album: "No Sleep 'Til Hammersmith",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/7325f79a-b3b8-48e0-b83c-ea548e20f217.jpg"
    },
    {
        id: 483,
        artist: "Soft Cell",
        album: "Non-Stop Erotic Cabaret",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/728eba9e-d660-4b04-882d-dd8858f024fd.jpg"
    },
    {
        id: 484,
        artist: "Orchestral Manoeuvres in the Dark",
        album: "Architecture & Morality",
        year: "1981",
        cover: "https://www.listchallenges.com/f/items/9a077f0d-9243-4220-9c00-b311cd24b863.jpg"
    },
    {
        id: 485,
        artist: "David Byrne & Brian Eno",
        album: "My Life in the Bush of Ghosts",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/5f6ea1f6-7e80-4727-9548-604e6deacea4.jpg"
    },
    {
        id: 486,
        artist: "Black Flag",
        album: "Damaged",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/b2728e8b-c96a-4aa5-a7e3-cbbb9709ce47.jpg"
    },
    {
        id: 487,
        artist: "X",
        album: "Wild Gift",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/667a47bd-f4e2-4846-8ab9-a2984cb88be8.jpg"
    },
    {
        id: 488,
        artist: "The Psychedelic Furs",
        album: "Talk Talk Talk",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/75724988-d476-4c88-8a2b-084d647f993e.jpg"
    },
    {
        id: 489,
        artist: "The Human League",
        album: "Dare",
        year: "None",
        cover: "None"
    },
    {
        id: 490,
        artist: "Gun Club",
        album: "Fire of Love",
        year: "None",
        cover: "None"
    },
    {
        id: 491,
        artist: "Bauhaus",
        album: "Mask",
        year: "None",
        cover: "None"
    },
    {
        id: 492,
        artist: "Bobby Womack",
        album: "The Poet",
        year: "1981",
        cover: "None"
    },
    {
        id: 493,
        artist: "Tom Tom Club",
        album: "Tom Tom Club",
        year: "1981",
        cover: "None"
    },
    {
        id: 494,
        artist: "Rush",
        album: "Moving Pictures",
        year: "1981",
        cover: "None"
    },
    {
        id: 495,
        artist: "ABBA",
        album: "The Visitors",
        year: "1981",
        cover: "None"
    },
    {
        id: 496,
        artist: "ABC",
        album: "The Lexicon of Love",
        year: "None",
        cover: "None"
    },
    {
        id: 497,
        artist: "Prince",
        album: "1999",
        year: "1982",
        cover: "None"
    },
    {
        id: 498,
        artist: "Elvis Costello & the Attractions",
        album: "Imperial Bedroom",
        year: "None",
        cover: "None"
    },
    {
        id: 499,
        artist: "Grandmaster Flash",
        album: "The Message",
        year: "None",
        cover: "None"
    },
    {
        id: 500,
        artist: "The Cure",
        album: "Pornography",
        year: "None",
        cover: "None"
    },
    {
        id: 501,
        artist: "Dexys Midnight Runners",
        album: "Too-Rye-Ay",
        year: "None",
        cover: "None"
    },
    {
        id: 502,
        artist: "Simple Minds",
        album: "New Gold Dream",
        year: "None",
        cover: "None"
    },
    {
        id: 503,
        artist: "Madness",
        album: "The Rise & Fall",
        year: "1982",
        cover: "None"
    },
    {
        id: 504,
        artist: "Donald Fagen",
        album: "The Nightfly",
        year: "None",
        cover: "None"
    },
    {
        id: 505,
        artist: "Haircut One Hundred",
        album: "Pelican West",
        year: "1982",
        cover: "None"
    },
    {
        id: 506,
        artist: "Kate Bush",
        album: "The Dreaming",
        year: "None",
        cover: "None"
    },
    {
        id: 507,
        artist: "Orange Juice",
        album: "Rip It Up",
        year: "1982",
        cover: "None"
    },
    {
        id: 508,
        artist: "Michael Jackson",
        album: "Thriller",
        year: "None",
        cover: "None"
    },
    {
        id: 509,
        artist: "The Birthday Party",
        album: "Junkyard",
        year: "None",
        cover: "None"
    },
    {
        id: 510,
        artist: "Venom",
        album: "Black Metal",
        year: "None",
        cover: "None"
    },
    {
        id: 511,
        artist: "Bruce Springsteen",
        album: "Nebraska",
        year: "None",
        cover: "None"
    },
    {
        id: 512,
        artist: "Associates",
        album: "Sulk",
        year: "1982",
        cover: "None"
    },
    {
        id: 513,
        artist: "Iron Maiden",
        album: "The Number of the Beast",
        year: "None",
        cover: "None"
    },
    {
        id: 514,
        artist: "Duran Duran",
        album: "Rio",
        year: "None",
        cover: "None"
    },
    {
        id: 515,
        artist: "Violent Femmes",
        album: "Violent Femmes",
        year: "None",
        cover: "None"
    },
    {
        id: 516,
        artist: "Malcolm Mclaren",
        album: "Duck Rock",
        year: "None",
        cover: "None"
    },
    {
        id: 517,
        artist: "Def Leppard",
        album: "Pyromania",
        year: "None",
        cover: "None"
    },
    {
        id: 518,
        artist: "R.E.M.",
        album: "Murmur",
        year: "None",
        cover: "None"
    },
    {
        id: 519,
        artist: "The The",
        album: "Soul Mining",
        year: "None",
        cover: "None"
    },
    {
        id: 520,
        artist: "Tom Waits",
        album: "Swordfishtrombones",
        year: "1983",
        cover: "None"
    },
    {
        id: 521,
        artist: "The Blue Nile",
        album: "A Walk Across the Rooftops",
        year: "1984",
        cover: "https://www.listchallenges.com/f/items/e81a1301-ddb7-448a-b425-cef8c221179b.jpg"
    },
    {
        id: 522,
        artist: "Hanoi Rocks",
        album: "Back to Mystery City",
        year: "1983",
        cover: "https://www.listchallenges.com/f/items/8cb52fe8-4428-491e-b2f4-e68e4c83e51e.jpg"
    },
    {
        id: 523,
        artist: "Cyndi Lauper",
        album: "She's So Unusual",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/2e1fcba7-175a-4dc3-805f-0abeada5a473.jpg"
    },
    {
        id: 524,
        artist: "Paul Simon",
        album: "Hearts and Bones",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/128b58a1-95a7-48de-b726-c190dad29923.jpg"
    },
    {
        id: 525,
        artist: "Echo and the Bunnymen",
        album: "Porcupine",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/f632f2d2-5c7d-408f-82d6-ac60ce74017b.jpg"
    },
    {
        id: 526,
        artist: "ZZ Top",
        album: "Eliminator",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/b54292a0-438f-46ee-b5de-ae8e22cfa836.jpg"
    },
    {
        id: 527,
        artist: "Eurythmics",
        album: "Sweet Dreams (Are Made of This)",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/fb55eb73-545b-4e26-adac-7278ba6ae77c.jpg"
    },
    {
        id: 528,
        artist: "U2",
        album: "War",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/296124fa-ac04-47d8-a33e-9688e5bfce82.jpg"
    },
    {
        id: 529,
        artist: "The Police",
        album: "Synchronicity",
        year: "1983",
        cover: "None"
    },
    {
        id: 530,
        artist: "Meat Puppets",
        album: "II",
        year: "None",
        cover: "None"
    },
    {
        id: 531,
        artist: "Culture Club",
        album: "Colour by Numbers",
        year: "None",
        cover: "None"
    },
    {
        id: 532,
        artist: "Frankie Goes to Hollywood",
        album: "Welcome to the Pleasuredome",
        year: "None",
        cover: "None"
    },
    {
        id: 533,
        artist: "Run DMC",
        album: "Run DMC",
        year: "None",
        cover: "None"
    },
    {
        id: 534,
        artist: "Sade",
        album: "Diamond Life",
        year: "None",
        cover: "None"
    },
    {
        id: 535,
        artist: "Cocteau Twins",
        album: "Treasure",
        year: "None",
        cover: "None"
    },
    {
        id: 536,
        artist: "Minor Threat",
        album: "Out of Step",
        year: "None",
        cover: "None"
    },
    {
        id: 537,
        artist: "Van Halen",
        album: "1984",
        year: "1984",
        cover: "None"
    },
    {
        id: 538,
        artist: "Prince",
        album: "Purple Rain",
        year: "None",
        cover: "None"
    },
    {
        id: 539,
        artist: "The Replacements",
        album: "Let It Be",
        year: "None",
        cover: "None"
    },
    {
        id: 540,
        artist: "The Style Council",
        album: "Café Bleu",
        year: "1984",
        cover: "None"
    },
    {
        id: 541,
        artist: "Tina Turner",
        album: "Private Dancer",
        year: "None",
        cover: "None"
    },
    {
        id: 542,
        artist: "Echo and the Bunnymen",
        album: "Ocean Rain",
        year: "None",
        cover: "None"
    },
    {
        id: 543,
        artist: "Minutemen",
        album: "Double Nickels on the Dime",
        year: "None",
        cover: "None"
    },
    {
        id: 544,
        artist: "Llyod Cole and the Commotions",
        album: "Rattlesnakes",
        year: "1984",
        cover: "None"
    },
    {
        id: 545,
        artist: "Youssou N'dour",
        album: "Immigres",
        year: "None",
        cover: "None"
    },
    {
        id: 546,
        artist: "Bruce Springsteen",
        album: "Born in the U.S.A.",
        year: "None",
        cover: "None"
    },
    {
        id: 547,
        artist: "The Fall",
        album: "This Nation's Saving Grace",
        year: "None",
        cover: "None"
    },
    {
        id: 548,
        artist: "Abdullah Ibrahim",
        album: "Water From an Ancient Well",
        year: "1985",
        cover: "None"
    },
    {
        id: 549,
        artist: "A-Ha",
        album: "Hunting High and Low",
        year: "1985",
        cover: "None"
    },
    {
        id: 550,
        artist: "Tears for Fears",
        album: "Songs From the Big Chair",
        year: "None",
        cover: "None"
    },
    {
        id: 551,
        artist: "Dire Straits",
        album: "Brothers in Arms",
        year: "1985",
        cover: "None"
    },
    {
        id: 552,
        artist: "Prefab Sprout",
        album: "Steve Mcqueen",
        year: "None",
        cover: "None"
    },
    {
        id: 553,
        artist: "The Mekons",
        album: "Fear and Whiskey",
        year: "None",
        cover: "None"
    },
    {
        id: 554,
        artist: "Big Black",
        album: "Atomizer",
        year: "None",
        cover: "None"
    },
    {
        id: 555,
        artist: "Suzanne Vega",
        album: "Suzanne Vega",
        year: "1985",
        cover: "None"
    },
    {
        id: 556,
        artist: "The Pogues",
        album: "Rum Sodomy and the Lash",
        year: "None",
        cover: "None"
    },
    {
        id: 557,
        artist: "Kate Bush",
        album: "Hounds of Love",
        year: "1985",
        cover: "None"
    },
    {
        id: 558,
        artist: "The Smiths",
        album: "Meat Is Murder",
        year: "1985",
        cover: "None"
    },
    {
        id: 559,
        artist: "Tom Waits",
        album: "Rain Dogs",
        year: "1985",
        cover: "None"
    },
    {
        id: 560,
        artist: "The Jesus and Mary Chain",
        album: "Psychocandy",
        year: "None",
        cover: "None"
    },
    {
        id: 561,
        artist: "New Order",
        album: "Low-Life",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/ea309e7a-66a1-4000-a74c-e94b1b576fda.jpg"
    },
    {
        id: 562,
        artist: "Simply Red",
        album: "Picture Book",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/eaf908c5-2946-4a4f-880d-60e2a3d50c52.jpg"
    },
    {
        id: 563,
        artist: "Dexy's Midnight Runners",
        album: "Don't Stand Me Down",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/0860ce0f-a579-4778-a921-f8a0ec872384.jpg"
    },
    {
        id: 564,
        artist: "Scritti Politti",
        album: "Cupid & Psyche 85",
        year: "1985",
        cover: "https://www.listchallenges.com/f/items/540a5291-6c66-4f2b-bd8f-42fe8d9c217a.jpg"
    },
    {
        id: 565,
        artist: "Elvis Costello",
        album: "Blood & Chocolate",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/45cf882a-b124-4721-a6fc-0101a9aa153a.jpg"
    },
    {
        id: 566,
        artist: "Afrika Bambaataa and the Soul Sonic Force",
        album: "Planet Rock",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/6dd70ae2-a106-426f-b2aa-808b60e67746.jpg"
    },
    {
        id: 567,
        artist: "Beastie Boys",
        album: "Licensed to Ill",
        year: "1986",
        cover: "https://www.listchallenges.com/f/items/229c3b92-5d2f-4bdb-b189-4e8b859f9713.jpg"
    },
    {
        id: 568,
        artist: "Metallica",
        album: "Master of Puppets",
        year: "1986",
        cover: "https://www.listchallenges.com/f/items/f7388919-e9bc-4016-a53d-c0673f5459bc.jpg"
    },
    {
        id: 569,
        artist: "The The",
        album: "Infected",
        year: "1986",
        cover: "None"
    },
    {
        id: 570,
        artist: "Nanci Griffith",
        album: "The Last of the True Believers",
        year: "1986",
        cover: "None"
    },
    {
        id: 571,
        artist: "Billy Bragg",
        album: "Talking With the Taxman About Poetry",
        year: "1986",
        cover: "None"
    },
    {
        id: 572,
        artist: "Talk Talk",
        album: "The Colour of Spring",
        year: "1985",
        cover: "None"
    },
    {
        id: 573,
        artist: "Megadeth",
        album: "Peace Sells...but Who's Buying?",
        year: "None",
        cover: "None"
    },
    {
        id: 574,
        artist: "Bon Jovi",
        album: "Slippery When Wet",
        year: "None",
        cover: "None"
    },
    {
        id: 575,
        artist: "Sonic Youth",
        album: "EVOL",
        year: "None",
        cover: "None"
    },
    {
        id: 576,
        artist: "Slayer",
        album: "Reign in Blood",
        year: "1986",
        cover: "None"
    },
    {
        id: 577,
        artist: "Throwing Muses",
        album: "Throwing Muses",
        year: "None",
        cover: "None"
    },
    {
        id: 578,
        artist: "Paul Simon",
        album: "Graceland",
        year: "None",
        cover: "None"
    },
    {
        id: 579,
        artist: "Run DMC",
        album: "Raising Hell",
        year: "None",
        cover: "None"
    },
    {
        id: 580,
        artist: "XTC",
        album: "Skylarking",
        year: "None",
        cover: "None"
    },
    {
        id: 581,
        artist: "Steve Earle",
        album: "Guitar Town",
        year: "None",
        cover: "None"
    },
    {
        id: 582,
        artist: "Bad Brains",
        album: "I Against I",
        year: "None",
        cover: "None"
    },
    {
        id: 583,
        artist: "Anita Baker",
        album: "Rapture",
        year: "None",
        cover: "None"
    },
    {
        id: 584,
        artist: "The Smiths",
        album: "The Queen Is Dead",
        year: "None",
        cover: "None"
    },
    {
        id: 585,
        artist: "Peter Gabriel",
        album: "So (special edition)",
        year: "None",
        cover: "None"
    },
    {
        id: 586,
        artist: "Anthrax",
        album: "Among the Living",
        year: "None",
        cover: "None"
    },
    {
        id: 587,
        artist: "Dinosaur Jr",
        album: "You're Living All Over Me",
        year: "None",
        cover: "None"
    },
    {
        id: 588,
        artist: "Dolly Parton, Emmylou Harris, Linda Ronstadt",
        album: "Trio",
        year: "None",
        cover: "None"
    },
    {
        id: 589,
        artist: "Def Leppard",
        album: "Hysteria",
        year: "None",
        cover: "None"
    },
    {
        id: 590,
        artist: "R.E.M.",
        album: "Document",
        year: "None",
        cover: "None"
    },
    {
        id: 591,
        artist: "Prince",
        album: "Sign 'O' the Times",
        year: "None",
        cover: "None"
    },
    {
        id: 592,
        artist: "The Cult",
        album: "Electric",
        year: "None",
        cover: "None"
    },
    {
        id: 593,
        artist: "Depeche Mode",
        album: "Music for the Masses",
        year: "None",
        cover: "None"
    },
    {
        id: 594,
        artist: "Sisters of Mercy",
        album: "Floodland",
        year: "None",
        cover: "None"
    },
    {
        id: 595,
        artist: "George Michael",
        album: "Faith",
        year: "None",
        cover: "None"
    },
    {
        id: 596,
        artist: "Hüsker Dü",
        album: "Warehouse: Songs and Stories",
        year: "None",
        cover: "None"
    },
    {
        id: 597,
        artist: "Butthole Surfers",
        album: "Locust Abortion Technician",
        year: "1987",
        cover: "None"
    },
    {
        id: 598,
        artist: "Astor Piazzolla & Gary Burton",
        album: "The New Tango",
        year: "1987",
        cover: "None"
    },
    {
        id: 599,
        artist: "The Smiths",
        album: "Strangeways, Here We Come",
        year: "None",
        cover: "None"
    },
    {
        id: 600,
        artist: "Guns N' Roses",
        album: "Appetite for Destruction",
        year: "None",
        cover: "None"
    },
    {
        id: 601,
        artist: "The Jesus and Mary Chains",
        album: "Darklands",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/0c0989c4-bc19-42c3-b421-5b73d6aaa78a.jpg"
    },
    {
        id: 602,
        artist: "Ladysmith Black Mambazo",
        album: "Shaka Zulu",
        year: "1987",
        cover: "https://www.listchallenges.com/f/items/ed40fbee-3c86-4265-91bf-cd2d6cb4d1af.jpg"
    },
    {
        id: 603,
        artist: "Laibach",
        album: "Opus Dei",
        year: "1987",
        cover: "https://www.listchallenges.com/f/items/e38e35e6-0262-4371-b41a-306c2ee6eb47.jpg"
    },
    {
        id: 604,
        artist: "Napalm Death",
        album: "Scum",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/06503dd2-42bb-4bc5-bc6d-d3c32ce0127e.jpg"
    },
    {
        id: 605,
        artist: "Sonic Youth",
        album: "Sister",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/e83a9727-3414-4a00-ac67-59c38ca484d9.jpg"
    },
    {
        id: 606,
        artist: "The Triffids",
        album: "Calenture",
        year: "1987",
        cover: "https://www.listchallenges.com/f/items/f80afc12-7b56-4f2a-8e52-3c37e0085cfe.jpg"
    },
    {
        id: 607,
        artist: "Michael Jackson",
        album: "Bad",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/26bebb78-10fb-419c-9adc-7c627c9f5440.jpg"
    },
    {
        id: 608,
        artist: "Pet Shop Boys",
        album: "Actually",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/6f9de207-a958-4d15-9c5d-35de327cc7a6.jpg"
    },
    {
        id: 609,
        artist: "U2",
        album: "The Joshua Tree",
        year: "None",
        cover: "None"
    },
    {
        id: 610,
        artist: "Sananda Maitreya",
        album: "Introducing the Hardline According to Terence Trent D'arby",
        year: "None",
        cover: "None"
    },
    {
        id: 611,
        artist: "The Pogues",
        album: "If I Should Fall From Grace With God",
        year: "1988",
        cover: "None"
    },
    {
        id: 612,
        artist: "Leonard Cohen",
        album: "I'm Your Man",
        year: "1988",
        cover: "None"
    },
    {
        id: 613,
        artist: "The Waterboys",
        album: "Fisherman's Blues",
        year: "None",
        cover: "None"
    },
    {
        id: 614,
        artist: "Fishbone",
        album: "Truth and Soul",
        year: "1988",
        cover: "None"
    },
    {
        id: 615,
        artist: "Everything but the Girl",
        album: "Idlewild",
        year: "1988",
        cover: "None"
    },
    {
        id: 616,
        artist: "Living Colour",
        album: "Vivid",
        year: "None",
        cover: "None"
    },
    {
        id: 617,
        artist: "Mudhoney",
        album: "Superfuzz Bigmuff",
        year: "None",
        cover: "None"
    },
    {
        id: 618,
        artist: "R.E.M.",
        album: "Green",
        year: "None",
        cover: "None"
    },
    {
        id: 619,
        artist: "Happy Mondays",
        album: "Bummed",
        year: "None",
        cover: "None"
    },
    {
        id: 620,
        artist: "The Go-Betweens",
        album: "16 Lovers Lane",
        year: "None",
        cover: "None"
    },
    {
        id: 621,
        artist: "Cowboy Junkies",
        album: "The Trinity Session",
        year: "1988",
        cover: "None"
    },
    {
        id: 622,
        artist: "Tracy Chapman",
        album: "Tracy Chapman",
        year: "1988",
        cover: "None"
    },
    {
        id: 623,
        artist: "My Bloody Valentine",
        album: "Isn't Anything",
        year: "None",
        cover: "None"
    },
    {
        id: 624,
        artist: "Pixies",
        album: "Surfer Rosa",
        year: "1988",
        cover: "None"
    },
    {
        id: 625,
        artist: "Metallica",
        album: "...And Justice for All",
        year: "1988",
        cover: "None"
    },
    {
        id: 626,
        artist: "Dinosaur Jr.",
        album: "Bug",
        year: "1988",
        cover: "None"
    },
    {
        id: 627,
        artist: "Dagmar Krause",
        album: "Tank Battles",
        year: "None",
        cover: "None"
    },
    {
        id: 628,
        artist: "K.D. Lang",
        album: "Shadowland",
        year: "None",
        cover: "None"
    },
    {
        id: 629,
        artist: "American Music Club",
        album: "California",
        year: "1988",
        cover: "None"
    },
    {
        id: 630,
        artist: "Morrissey",
        album: "Viva Hate",
        year: "None",
        cover: "None"
    },
    {
        id: 631,
        artist: "Sonic Youth",
        album: "Daydream Nation",
        year: "1988",
        cover: "None"
    },
    {
        id: 632,
        artist: "The Sugarcubes",
        album: "Life's Too Good",
        year: "1988",
        cover: "None"
    },
    {
        id: 633,
        artist: "Dwight Yoakam",
        album: "Buenas Noches From a Lonely Room",
        year: "1988",
        cover: "None"
    },
    {
        id: 634,
        artist: "Public Enemy",
        album: "It Takes a Nation of Millions to Hold Us Back",
        year: "1988",
        cover: "None"
    },
    {
        id: 635,
        artist: "Jane's Addiction",
        album: "Nothing's Shocking",
        year: "None",
        cover: "None"
    },
    {
        id: 636,
        artist: "Faith No More",
        album: "The Real Thing",
        year: "None",
        cover: "None"
    },
    {
        id: 637,
        artist: "Lenny Kravitz",
        album: "Let Love Rule",
        year: "1989",
        cover: "None"
    },
    {
        id: 638,
        artist: "John Lee Hooker",
        album: "The Healer",
        year: "1989",
        cover: "None"
    },
    {
        id: 639,
        artist: "New Order",
        album: "Technique",
        year: "None",
        cover: "None"
    },
    {
        id: 640,
        artist: "Madonna",
        album: "Like a Prayer",
        year: "None",
        cover: "None"
    },
    {
        id: 641,
        artist: "Queen Latifah",
        album: "All Hail the Queen",
        year: "1989",
        cover: "https://www.listchallenges.com/f/items/980f4b3e-c842-4ebc-9234-addd72fdc9b7.jpg"
    },
    {
        id: 642,
        artist: "Firehose",
        album: "Fromohio",
        year: "1989",
        cover: "https://www.listchallenges.com/f/items/f96eb420-58f1-4611-8d16-7e16b57ceb01.jpg"
    },
    {
        id: 643,
        artist: "Spacemen 3",
        album: "Playing With Fire",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/0b601e82-0fc9-4344-82e1-94a425667b1b.jpg"
    },
    {
        id: 644,
        artist: "The Beastie Boys",
        album: "Paul's Boutique",
        year: "1989",
        cover: "https://www.listchallenges.com/f/items/0aa8880d-1815-4d23-b2d6-45a284cb82d4.jpg"
    },
    {
        id: 645,
        artist: "The Young Gods",
        album: "L'eau Rouge",
        year: "1989",
        cover: "https://www.listchallenges.com/f/items/19a800c9-b586-49d0-befc-a0666de8a4b0.jpg"
    },
    {
        id: 646,
        artist: "John Zorn",
        album: "Spy Vs. Spy",
        year: "1989",
        cover: "https://www.listchallenges.com/f/items/5f321af2-96c8-4777-b00d-ecb6274036ac.jpg"
    },
    {
        id: 647,
        artist: "The Stone Roses",
        album: "The Stone Roses",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/1c81980a-5d38-4fe2-ac88-f5fba3ed580c.jpg"
    },
    {
        id: 648,
        artist: "Raw Like Sushi",
        album: "Neneh Cherry",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/ccf1ba57-5ae5-4224-ad57-2ec53b7f509e.jpg"
    },
    {
        id: 649,
        artist: "Baaba Maal & Mansour Seck",
        album: "Djam Leelii",
        year: "1989",
        cover: "None"
    },
    {
        id: 650,
        artist: "Kate Bush",
        album: "The Sensual World",
        year: "1989",
        cover: "None"
    },
    {
        id: 651,
        artist: "808 State",
        album: "90",
        year: "1989",
        cover: "None"
    },
    {
        id: 652,
        artist: "The Cure",
        album: "Disintegration",
        year: "1989",
        cover: "None"
    },
    {
        id: 653,
        artist: "Coldcut",
        album: "What's That Noise?",
        year: "None",
        cover: "None"
    },
    {
        id: 654,
        artist: "Barry Adamson",
        album: "Moss Side Story",
        year: "1989",
        cover: "None"
    },
    {
        id: 655,
        artist: "Aerosmith",
        album: "Pump",
        year: "None",
        cover: "None"
    },
    {
        id: 656,
        artist: "Pixies",
        album: "Doolittle",
        year: "None",
        cover: "None"
    },
    {
        id: 657,
        artist: "Bonnie Raitt",
        album: "Nick of Time",
        year: "1989",
        cover: "None"
    },
    {
        id: 658,
        artist: "Fugazi",
        album: "Repeater",
        year: "None",
        cover: "None"
    },
    {
        id: 659,
        artist: "Soul II Soul",
        album: "Club Classics Vol. One",
        year: "None",
        cover: "None"
    },
    {
        id: 660,
        artist: "De La Soul",
        album: "3 Feet High and Rising",
        year: "None",
        cover: "None"
    },
    {
        id: 661,
        artist: "Janet Jackson",
        album: "Rhythm Nation 1814",
        year: "None",
        cover: "None"
    },
    {
        id: 662,
        artist: "Jungle Brothers",
        album: "Done by the Forces of Nature",
        year: "1989",
        cover: "None"
    },
    {
        id: 663,
        artist: "N.W.A",
        album: "Straight Outta Compton",
        year: "1988",
        cover: "None"
    },
    {
        id: 664,
        artist: "Cocteau Twins",
        album: "Heaven or Las Vegas",
        year: "1990",
        cover: "None"
    },
    {
        id: 665,
        artist: "Deee-Lite",
        album: "World Clique",
        year: "1990",
        cover: "None"
    },
    {
        id: 666,
        artist: "The La's",
        album: "the La's",
        year: "1990",
        cover: "None"
    },
    {
        id: 667,
        artist: "The Shamen",
        album: "En-Tact",
        year: "1990",
        cover: "None"
    },
    {
        id: 668,
        artist: "Black Crowes",
        album: "Shake Your Money Maker",
        year: "None",
        cover: "None"
    },
    {
        id: 669,
        artist: "Depeche Mode",
        album: "Violator",
        year: "1990",
        cover: "None"
    },
    {
        id: 670,
        artist: "Pixies",
        album: "Bossanova",
        year: "None",
        cover: "None"
    },
    {
        id: 671,
        artist: "Megadeth",
        album: "Rust in Peace",
        year: "None",
        cover: "None"
    },
    {
        id: 672,
        artist: "Sex Packets (1990)",
        album: "Digital Underground",
        year: "None",
        cover: "None"
    },
    {
        id: 673,
        artist: "Pet Shop Boys",
        album: "Behaviour",
        year: "None",
        cover: "None"
    },
    {
        id: 674,
        artist: "Happy Mondays",
        album: "Pills N Thrills and Bellyaches",
        year: "None",
        cover: "None"
    },
    {
        id: 675,
        artist: "George Michael",
        album: "Listen Without Prejudice: Vol 1",
        year: "None",
        cover: "None"
    },
    {
        id: 676,
        artist: "Ice Cube",
        album: "Amerikkka's Most Wanted",
        year: "None",
        cover: "None"
    },
    {
        id: 677,
        artist: "Neil Young",
        album: "Ragged Glory",
        year: "None",
        cover: "None"
    },
    {
        id: 678,
        artist: "Jane's Addiction",
        album: "Ritual De Lo Habitual",
        year: "1990",
        cover: "None"
    },
    {
        id: 679,
        artist: "LL Cool J",
        album: "Mama Said Knock You Out",
        year: "None",
        cover: "None"
    },
    {
        id: 680,
        artist: "Public Enemy",
        album: "Fear of a Black Planet",
        year: "None",
        cover: "None"
    },
    {
        id: 681,
        artist: "Sinead O'connor",
        album: "I Do Not Want What I Haven't Got",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/383ea908-b8e6-4cf0-a30b-3838ccdf40c3.jpg"
    },
    {
        id: 682,
        artist: "A Tribe Called Quest",
        album: "People's Instinctive Travels",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/758dfa4f-538d-476e-8869-91568210af12.jpg"
    },
    {
        id: 683,
        artist: "Sonic Youth",
        album: "Goo",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/f320606a-d66a-48a4-909b-a8d6280eb6ac.jpg"
    },
    {
        id: 684,
        artist: "Ride",
        album: "Nowhere",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/519c9581-0d9e-4a0b-b0a3-3d60cdca3092.jpg"
    },
    {
        id: 685,
        artist: "My Bloody Valentine",
        album: "Loveless",
        year: "1991",
        cover: "https://www.listchallenges.com/f/items/ad3d4276-1955-4221-8c5d-e290fd06c988.jpg"
    },
    {
        id: 686,
        artist: "Nirvana",
        album: "Nevermind",
        year: "1991",
        cover: "https://www.listchallenges.com/f/items/a8c53efb-ed1b-4de3-9c7e-df598e78e8e5.jpg"
    },
    {
        id: 687,
        artist: "Crowded House",
        album: "Woodface",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/76ddbabe-fde5-4768-b033-45886ab1544b.jpg"
    },
    {
        id: 688,
        artist: "Cypress Hill",
        album: "Cypress Hill",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/f505103f-8074-4cdd-bc1a-5db7797dc89e.jpg"
    },
    {
        id: 689,
        artist: "Julian Cope",
        album: "Peggy Suicide",
        year: "None",
        cover: "None"
    },
    {
        id: 690,
        artist: "MC Solar",
        album: "Qui sème le vent récolte le tempo",
        year: "None",
        cover: "None"
    },
    {
        id: 691,
        artist: "Gang Starr",
        album: "Step in the Arena",
        year: "None",
        cover: "None"
    },
    {
        id: 692,
        artist: "Jah Wobble",
        album: "Rising Above Bedlam",
        year: "None",
        cover: "None"
    },
    {
        id: 693,
        artist: "Red Hot Chili Peppers",
        album: "Blood Sugar Sex Magik",
        year: "None",
        cover: "None"
    },
    {
        id: 694,
        artist: "Ice T",
        album: "O.G. Original Gangster (1991)",
        year: "None",
        cover: "None"
    },
    {
        id: 695,
        artist: "Mudhoney",
        album: "Every Good Boy Deserves Fudge",
        year: "None",
        cover: "None"
    },
    {
        id: 696,
        artist: "Public Enemy",
        album: "Apocalypse 91... The Enemy Strikes Black",
        year: "None",
        cover: "None"
    },
    {
        id: 697,
        artist: "A Tribe Called Quest",
        album: "Low End Theory",
        year: "None",
        cover: "None"
    },
    {
        id: 698,
        artist: "Saint Etienne",
        album: "Fox Base Alpha",
        year: "None",
        cover: "None"
    },
    {
        id: 699,
        artist: "Pearl Jam",
        album: "Ten",
        year: "1991",
        cover: "None"
    },
    {
        id: 700,
        artist: "Slint",
        album: "Spiderland",
        year: "1991",
        cover: "None"
    },
    {
        id: 701,
        artist: "Sepultura",
        album: "Arise",
        year: "None",
        cover: "None"
    },
    {
        id: 702,
        artist: "U2",
        album: "Achtung Baby",
        year: "None",
        cover: "None"
    },
    {
        id: 703,
        artist: "The KLF",
        album: "The White Room",
        year: "None",
        cover: "None"
    },
    {
        id: 704,
        artist: "Massive Attack",
        album: "Blue Lines",
        year: "None",
        cover: "None"
    },
    {
        id: 705,
        artist: "Primal Scream",
        album: "Screamadelica",
        year: "None",
        cover: "None"
    },
    {
        id: 706,
        artist: "Teenage Fanclub",
        album: "Bandwagonesque",
        year: "None",
        cover: "None"
    },
    {
        id: 707,
        artist: "Metallica",
        album: "Metallica",
        year: "None",
        cover: "None"
    },
    {
        id: 708,
        artist: "Pavement",
        album: "Slanted & Enchanted",
        year: "None",
        cover: "None"
    },
    {
        id: 709,
        artist: "Aphex Twin",
        album: "Selected Ambient Works 85-92",
        year: "None",
        cover: "None"
    },
    {
        id: 710,
        artist: "Arrested Development",
        album: "Three Years, Five Months, and Two Days in the Life of ...",
        year: "None",
        cover: "None"
    },
    {
        id: 711,
        artist: "Koffi Olomidé",
        album: "Haut De Gamme / Koweït Rive Gauche",
        year: "None",
        cover: "None"
    },
    {
        id: 712,
        artist: "Morrissey",
        album: "Your Arsenal",
        year: "None",
        cover: "None"
    },
    {
        id: 713,
        artist: "Baaba Maal",
        album: "Lam Torro",
        year: "None",
        cover: "None"
    },
    {
        id: 714,
        artist: "Lemonheads",
        album: "It's a Shame About Ray",
        year: "None",
        cover: "None"
    },
    {
        id: 715,
        artist: "Rage Against the Machine",
        album: "Rage Against the Machine",
        year: "1992",
        cover: "None"
    },
    {
        id: 716,
        artist: "Disposable Heroes of Hiphoprisy",
        album: "Hypocrisy Is the Greatest Luxury",
        year: "None",
        cover: "None"
    },
    {
        id: 717,
        artist: "K.D. Lang",
        album: "Ingenue",
        year: "None",
        cover: "None"
    },
    {
        id: 718,
        artist: "Dr. Dre",
        album: "The Chronic",
        year: "1992",
        cover: "None"
    },
    {
        id: 719,
        artist: "R.E.M.",
        album: "Automatic for the People",
        year: "None",
        cover: "None"
    },
    {
        id: 720,
        artist: "The Pharcyde",
        album: "Bizarre Ride II the Pharcyde",
        year: "1992",
        cover: "None"
    },
    {
        id: 721,
        artist: "Spiritualized",
        album: "Laser Guided Melodies",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/70ea4c2b-920d-48c1-a8c6-f3407f787245.jpg"
    },
    {
        id: 722,
        artist: "Sugar",
        album: "Copper Blue",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/1e753b4f-4a13-492b-ab38-19270bbe5251.jpg"
    },
    {
        id: 723,
        artist: "Tom Waits",
        album: "Bone Machine",
        year: "1992",
        cover: "https://www.listchallenges.com/f/items/93df3aa5-930b-4a30-a00a-25622fc0fc39.jpg"
    },
    {
        id: 724,
        artist: "Sonic Youth",
        album: "Dirty",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/03310cda-271b-4ad9-b550-bbdb025ce687.jpg"
    },
    {
        id: 725,
        artist: "Stereo MC's",
        album: "Connected",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/76b3aace-5157-4c9c-8f5a-2d3f0afac6e3.jpg"
    },
    {
        id: 726,
        artist: "Ministry",
        album: "Psalm 69",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/8b72b366-13c1-45a0-a1ab-be194d28de47.jpg"
    },
    {
        id: 727,
        artist: "Tori Amos",
        album: "Little Earthquakes",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/a158c921-19ca-42f5-8823-a31ade48efe0.jpg"
    },
    {
        id: 728,
        artist: "Ice Cube",
        album: "The Predator",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/5948023e-3988-4e50-9119-84cb830fffc8.jpg"
    },
    {
        id: 729,
        artist: "Pantera",
        album: "Vulgar Display of Power",
        year: "None",
        cover: "None"
    },
    {
        id: 730,
        artist: "Alice in Chains",
        album: "Dirt",
        year: "1992",
        cover: "None"
    },
    {
        id: 731,
        artist: "Nick Cave and the Bad Seeds",
        album: "By Henry's Dream",
        year: "None",
        cover: "None"
    },
    {
        id: 732,
        artist: "Ali Fateh Nusart Khan",
        album: "Devotional Songs",
        year: "None",
        cover: "None"
    },
    {
        id: 733,
        artist: "PJ Harvey",
        album: "Dry",
        year: "None",
        cover: "None"
    },
    {
        id: 734,
        artist: "Suede",
        album: "Suede",
        year: "None",
        cover: "None"
    },
    {
        id: 735,
        artist: "Paul Weller",
        album: "Wild Wood",
        year: "None",
        cover: "None"
    },
    {
        id: 736,
        artist: "Smashing Pumpkins",
        album: "Siamese Dream",
        year: "None",
        cover: "None"
    },
    {
        id: 737,
        artist: "The Auteurs",
        album: "New Wave",
        year: "None",
        cover: "None"
    },
    {
        id: 738,
        artist: "Liz Phair",
        album: "Exile in Guyville",
        year: "None",
        cover: "None"
    },
    {
        id: 739,
        artist: "Afghan Whigs",
        album: "Gentlemen",
        year: "None",
        cover: "None"
    },
    {
        id: 740,
        artist: "Aimee Mann",
        album: "Whatever",
        year: "None",
        cover: "None"
    },
    {
        id: 741,
        artist: "Grant Lee Buffalo",
        album: "Fuzzy",
        year: "None",
        cover: "None"
    },
    {
        id: 742,
        artist: "Nirvana",
        album: "In Utero",
        year: "1993",
        cover: "None"
    },
    {
        id: 743,
        artist: "Jamiroquai",
        album: "Emergency on Planet Earth",
        year: "None",
        cover: "None"
    },
    {
        id: 744,
        artist: "Pet Shop Boys",
        album: "Very",
        year: "None",
        cover: "None"
    },
    {
        id: 745,
        artist: "PJ Harvey",
        album: "Rid of Me",
        year: "None",
        cover: "None"
    },
    {
        id: 746,
        artist: "Blur",
        album: "Modern Life Is Rubbish",
        year: "None",
        cover: "None"
    },
    {
        id: 747,
        artist: "Sheryl Crow",
        album: "Tuesday Night Music Club",
        year: "None",
        cover: "None"
    },
    {
        id: 748,
        artist: "The Fall",
        album: "The Infotainment Scan",
        year: "None",
        cover: "None"
    },
    {
        id: 749,
        artist: "Wu-Tang Clan",
        album: "Enter the Wu-Tang (36 Chambers)",
        year: "1993",
        cover: "None"
    },
    {
        id: 750,
        artist: "Björk",
        album: "Debut",
        year: "1993",
        cover: "None"
    },
    {
        id: 751,
        artist: "Orbital",
        album: "Orbital 2",
        year: "None",
        cover: "None"
    },
    {
        id: 752,
        artist: "Snoop Doggy Dogg",
        album: "Doggystyle",
        year: "1993",
        cover: "None"
    },
    {
        id: 753,
        artist: "Sebadoh",
        album: "Bubble and Scrape",
        year: "None",
        cover: "None"
    },
    {
        id: 754,
        artist: "The Boo Radleys",
        album: "Giant Steps",
        year: "None",
        cover: "None"
    },
    {
        id: 755,
        artist: "William Orbit",
        album: "Strange Cargo Lll",
        year: "None",
        cover: "None"
    },
    {
        id: 756,
        artist: "Method Man",
        album: "Tical",
        year: "None",
        cover: "None"
    },
    {
        id: 757,
        artist: "Frank Black",
        album: "Teenager of the Year",
        year: "None",
        cover: "None"
    },
    {
        id: 758,
        artist: "Girls Against Boys",
        album: "Venus Luxure No 1 Baby",
        year: "None",
        cover: "None"
    },
    {
        id: 759,
        artist: "Jeru the Damaja",
        album: "The Sun Rises in the East",
        year: "None",
        cover: "None"
    },
    {
        id: 760,
        artist: "Pavement",
        album: "Crooked Rain, Crooked Rain",
        year: "None",
        cover: "None"
    },
    {
        id: 761,
        artist: "Portishead",
        album: "Dummy",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/9ce63379-3f21-43ef-9c6a-4720a4f69cc1.jpg"
    },
    {
        id: 762,
        artist: "Sabres of Paradise",
        album: "Haunted Dancehall",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/b4252793-7568-4ff3-9fe0-fbce3885dc40.jpg"
    },
    {
        id: 763,
        artist: "Nas",
        album: "Illmatic",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/5fe17c48-c089-4a66-a15f-a0e36d3540ed.jpg"
    },
    {
        id: 764,
        artist: "Beastie Boys",
        album: "Ill Communication",
        year: "1994",
        cover: "https://www.listchallenges.com/f/items/4d90636f-2bf8-400f-85f6-6872ded9e879.jpg"
    },
    {
        id: 765,
        artist: "Elvis Costello",
        album: "Brutal Youth",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/1044c606-d614-4f0d-baec-3af9dfb69b3e.jpg"
    },
    {
        id: 766,
        artist: "Morrissey",
        album: "Vauxhall and I",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/5835f492-5bb8-4ad6-9b2b-0b37e6c87854.jpg"
    },
    {
        id: 767,
        artist: "TLC",
        album: "Crazysexycool",
        year: "1994",
        cover: "https://www.listchallenges.com/f/items/bf54f98d-474a-4c70-9317-6dd3e4a20dc7.jpg"
    },
    {
        id: 768,
        artist: "Oasis",
        album: "Definitely Maybe",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/e9d93fe4-87cf-4013-8545-3660d0ed6df8.jpg"
    },
    {
        id: 769,
        artist: "Soundgarden",
        album: "Superunknown",
        year: "1994",
        cover: "None"
    },
    {
        id: 770,
        artist: "The Offspring",
        album: "Smash",
        year: "1994",
        cover: "None"
    },
    {
        id: 771,
        artist: "Drive Like Jehu",
        album: "Yank Crime",
        year: "1994",
        cover: "None"
    },
    {
        id: 772,
        artist: "Blur",
        album: "Parklife",
        year: "None",
        cover: "None"
    },
    {
        id: 773,
        artist: "G Love & Special Sauce",
        album: "G Love & Special Sauce",
        year: "None",
        cover: "None"
    },
    {
        id: 774,
        artist: "Ali Farka Toure and Ry Cooder",
        album: "Talking Timbuktu",
        year: "None",
        cover: "None"
    },
    {
        id: 775,
        artist: "Hole",
        album: "Live Through This",
        year: "None",
        cover: "None"
    },
    {
        id: 776,
        artist: "Massive Attack",
        album: "Protection",
        year: "None",
        cover: "None"
    },
    {
        id: 777,
        artist: "Manic Street Preachers",
        album: "The Holy Bible",
        year: "None",
        cover: "None"
    },
    {
        id: 778,
        artist: "Suede",
        album: "Dog Man Star",
        year: "None",
        cover: "None"
    },
    {
        id: 779,
        artist: "The Notorious B.I.G",
        album: "Ready to Die",
        year: "None",
        cover: "None"
    },
    {
        id: 780,
        artist: "Jeff Buckley",
        album: "Grace",
        year: "None",
        cover: "None"
    },
    {
        id: 781,
        artist: "Orbital",
        album: "Snivilisation",
        year: "None",
        cover: "None"
    },
    {
        id: 782,
        artist: "Nirvana",
        album: "MTV Unplugged in New York",
        year: "1994",
        cover: "None"
    },
    {
        id: 783,
        artist: "Nine Inch Nails",
        album: "The Downward Spiral",
        year: "None",
        cover: "None"
    },
    {
        id: 784,
        artist: "The Prodigy",
        album: "Music for the Jilted Generation",
        year: "None",
        cover: "None"
    },
    {
        id: 785,
        artist: "Green Day",
        album: "Dookie",
        year: "None",
        cover: "None"
    },
    {
        id: 786,
        artist: "Foo Fighters",
        album: "Foo Fighters",
        year: "None",
        cover: "None"
    },
    {
        id: 787,
        artist: "Garbage",
        album: "Garbage",
        year: "1995",
        cover: "None"
    },
    {
        id: 788,
        artist: "Nightmares on Wax Smokers",
        album: "Delight",
        year: "None",
        cover: "None"
    },
    {
        id: 789,
        artist: "Tricky",
        album: "Maxinquaye",
        year: "None",
        cover: "None"
    },
    {
        id: 790,
        artist: "Raekwon",
        album: "Only Built 4 Cuban Linx",
        year: "None",
        cover: "None"
    },
    {
        id: 791,
        artist: "Smashing Pumpkins",
        album: "Mellon Collie and the Infinite Sadness",
        year: "None",
        cover: "None"
    },
    {
        id: 792,
        artist: "Rocket From the Crypt",
        album: "Scream Dracula Scream",
        year: "None",
        cover: "None"
    },
    {
        id: 793,
        artist: "The Chemical Brothers",
        album: "Exit Planet Dust",
        year: "None",
        cover: "None"
    },
    {
        id: 794,
        artist: "2Pac",
        album: "Me Against the World",
        year: "None",
        cover: "None"
    },
    {
        id: 795,
        artist: "Elastica",
        album: "Elastica",
        year: "None",
        cover: "None"
    },
    {
        id: 796,
        artist: "Supergrass",
        album: "I Should Coco",
        year: "None",
        cover: "None"
    },
    {
        id: 797,
        artist: "Radiohead",
        album: "The Bends",
        year: "None",
        cover: "None"
    },
    {
        id: 798,
        artist: "Guided by Voices",
        album: "Alien Lanes",
        year: "None",
        cover: "None"
    },
    {
        id: 799,
        artist: "Femi Kutti",
        album: "Femi Kutti",
        year: "None",
        cover: "None"
    },
    {
        id: 800,
        artist: "The Verve",
        album: "A Northern Soul",
        year: "None",
        cover: "None"
    },
    {
        id: 801,
        artist: "GZA",
        album: "Liquid Swords",
        year: "1995",
        cover: "https://www.listchallenges.com/f/items/738d0613-b28b-40bb-8b64-86fdae6d8b2c.jpg"
    },
    {
        id: 802,
        artist: "Pulp",
        album: "Different Class",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/46d54fb6-6e10-4b03-9b97-a3114c467b76.jpg"
    },
    {
        id: 803,
        artist: "Leftfield",
        album: "Leftism",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/ebbcedfc-a1bb-4f3b-95bc-52748a958348.jpg"
    },
    {
        id: 804,
        artist: "D'angelo",
        album: "Brown Sugar",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/e5c2cff1-14a9-4299-bf7c-5584579c240b.jpg"
    },
    {
        id: 805,
        artist: "Oasis",
        album: "(What's the Story) Morning Glory?",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/5ab3b07a-3659-4f91-b252-ad49f781c26a.jpg"
    },
    {
        id: 806,
        artist: "Goldie",
        album: "Timeless",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/1ec2167c-befd-4f1f-8bdb-259720ab56e4.jpg"
    },
    {
        id: 807,
        artist: "Alanis Morissette",
        album: "Jagged Little Pill",
        year: "1995",
        cover: "https://www.listchallenges.com/f/items/a64108fd-2cc1-4ffd-980e-eb966f372a5f.jpg"
    },
    {
        id: 808,
        artist: "Screaming Trees",
        album: "Dust",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/3a4a7064-d8e2-45af-affb-05d9a77d4c5d.jpg"
    },
    {
        id: 809,
        artist: "Super Furry Animals",
        album: "Fuzzy Logic",
        year: "None",
        cover: "None"
    },
    {
        id: 810,
        artist: "Fatboy Slim",
        album: "Better Living Through Chemistry",
        year: "None",
        cover: "None"
    },
    {
        id: 811,
        artist: "Dr. Octagon",
        album: "Dr. Octagonecologyst",
        year: "1996",
        cover: "None"
    },
    {
        id: 812,
        artist: "Stereolab",
        album: "Emperor Tomato Ketchup",
        year: "None",
        cover: "None"
    },
    {
        id: 813,
        artist: "Tortoise",
        album: "Millions Now Living Will Never Die",
        year: "None",
        cover: "None"
    },
    {
        id: 814,
        artist: "Beck",
        album: "Odelay",
        year: "None",
        cover: "None"
    },
    {
        id: 815,
        artist: "Belle & Sebastian",
        album: "Tigermilk",
        year: "None",
        cover: "None"
    },
    {
        id: 816,
        artist: "Dj Shadow",
        album: "Endtroducing.....",
        year: "1996",
        cover: "None"
    },
    {
        id: 817,
        artist: "Eels",
        album: "Beautiful Freak",
        year: "None",
        cover: "None"
    },
    {
        id: 818,
        artist: "The Divine Comedy",
        album: "Casanova",
        year: "1996",
        cover: "None"
    },
    {
        id: 819,
        artist: "Fiona Apple",
        album: "Tidal",
        year: "None",
        cover: "None"
    },
    {
        id: 820,
        artist: "Wilco",
        album: "Being There",
        year: "1996",
        cover: "None"
    },
    {
        id: 821,
        artist: "Sepultura",
        album: "Roots",
        year: "None",
        cover: "None"
    },
    {
        id: 822,
        artist: "Barry Adamson",
        album: "Oedipus Schmoedipus",
        year: "None",
        cover: "None"
    },
    {
        id: 823,
        artist: "Fun Lovin' Criminals",
        album: "Come Find Yourself",
        year: "None",
        cover: "None"
    },
    {
        id: 824,
        artist: "Maxwell",
        album: "Urban Hang Suite",
        year: "None",
        cover: "None"
    },
    {
        id: 825,
        artist: "The Charlatans",
        album: "Tellin' Stories",
        year: "None",
        cover: "None"
    },
    {
        id: 826,
        artist: "Manic Street Preachers",
        album: "Everything Must Go",
        year: "None",
        cover: "None"
    },
    {
        id: 827,
        artist: "Everything but the Girl",
        album: "Walking Wounded",
        year: "None",
        cover: "None"
    },
    {
        id: 828,
        artist: "Nick Cave & the Bad Seeds",
        album: "Murder Ballads",
        year: "1996",
        cover: "None"
    },
    {
        id: 829,
        artist: "Ltj Bukem",
        album: "Logical Progression",
        year: "None",
        cover: "None"
    },
    {
        id: 830,
        artist: "Underworld",
        album: "Second Toughest in the Infants",
        year: "None",
        cover: "None"
    },
    {
        id: 831,
        artist: "Jon Spencer",
        album: "Blues Group Now I Got Worry",
        year: "None",
        cover: "None"
    },
    {
        id: 832,
        artist: "Cardigans",
        album: "First Band on the Moon",
        year: "None",
        cover: "None"
    },
    {
        id: 833,
        artist: "Marilyn Manson",
        album: "Antichrist Superstar",
        year: "None",
        cover: "None"
    },
    {
        id: 834,
        artist: "Ash",
        album: "1977",
        year: "1996",
        cover: "None"
    },
    {
        id: 835,
        artist: "The Fugees",
        album: "The Score",
        year: "1996",
        cover: "None"
    },
    {
        id: 836,
        artist: "Belle and Sebastian",
        album: "If You're Feeling Sinister",
        year: "None",
        cover: "None"
    },
    {
        id: 837,
        artist: "Blur",
        album: "Blur",
        year: "None",
        cover: "None"
    },
    {
        id: 838,
        artist: "Radiohead",
        album: "OK Computer",
        year: "1997",
        cover: "None"
    },
    {
        id: 839,
        artist: "Finely Quaye",
        album: "Maverick a Strike",
        year: "1997",
        cover: "None"
    },
    {
        id: 840,
        artist: "Missy 'Misdemeanor' Elliott",
        album: "Supa Dupa Fly",
        year: "1997",
        cover: "None"
    },
    {
        id: 841,
        artist: "The Chemical Brothers",
        album: "Dig Your Own Hole",
        year: "1997",
        cover: "https://www.listchallenges.com/f/items/c1cdc710-48da-4b0f-86f9-ba44aaaac51a.jpg"
    },
    {
        id: 842,
        artist: "Primal Scream",
        album: "Vanishing Point",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/9d9bc295-374b-4222-98e5-9c5052c3c433.jpg"
    },
    {
        id: 843,
        artist: "Robert Wyatt",
        album: "Shleep",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/6404c305-d72d-4581-b469-63dd6b99baf8.jpg"
    },
    {
        id: 844,
        artist: "Sleater-Kinney",
        album: "Dig Me Out",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/e21058bd-d60e-4d5a-a140-bcdbb7821f7d.jpg"
    },
    {
        id: 845,
        artist: "David Holmes",
        album: "Lets Get Killed",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/e0b76f6c-b46d-4bdb-af9d-f622d52a631f.jpg"
    },
    {
        id: 846,
        artist: "The Prodigy",
        album: "The Fat of the Land",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/91c51f7a-4971-4198-abdf-89ae6e1865f8.jpg"
    },
    {
        id: 847,
        artist: "Buena Vista Social Club",
        album: "Buena Vista Social Club",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/c432ade7-6978-4dc5-ab61-e479003f0ab5.jpg"
    },
    {
        id: 848,
        artist: "Nick Cave and the Bad Seeds",
        album: "The Boatman's Call",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/e9bcc1a6-cda2-4380-b847-1baa90457316.jpg"
    },
    {
        id: 849,
        artist: "Divine Comedy",
        album: "A Short Album About Love",
        year: "None",
        cover: "None"
    },
    {
        id: 850,
        artist: "Cornershop",
        album: "When I Was Born for the 7th Time",
        year: "None",
        cover: "None"
    },
    {
        id: 851,
        artist: "Daft Punk",
        album: "Homework",
        year: "None",
        cover: "None"
    },
    {
        id: 852,
        artist: "Robbie Williams",
        album: "Life Thru a Lens",
        year: "None",
        cover: "None"
    },
    {
        id: 853,
        artist: "Mariah Carey",
        album: "Butterfly",
        year: "None",
        cover: "None"
    },
    {
        id: 854,
        artist: "Supergrass",
        album: "In It for the Money",
        year: "None",
        cover: "None"
    },
    {
        id: 855,
        artist: "Bob Dylan",
        album: "Time Out of Mind",
        year: "None",
        cover: "None"
    },
    {
        id: 856,
        artist: "Reprazent and Roni Size",
        album: "New Forms",
        year: "None",
        cover: "None"
    },
    {
        id: 857,
        artist: "Elliott Smith",
        album: "Either/Or",
        year: "None",
        cover: "None"
    },
    {
        id: 858,
        artist: "The Verve",
        album: "Urban Hymns",
        year: "None",
        cover: "None"
    },
    {
        id: 859,
        artist: "Spiritualized",
        album: "Ladies and Gentlemen We Are Floating in Space",
        year: "None",
        cover: "None"
    },
    {
        id: 860,
        artist: "System of a Down",
        album: "System of a Down",
        year: "None",
        cover: "None"
    },
    {
        id: 861,
        artist: "Bob Dylan",
        album: "Live 1966",
        year: "1998",
        cover: "None"
    },
    {
        id: 862,
        artist: "Manu Chao",
        album: "Clandestino",
        year: "None",
        cover: "None"
    },
    {
        id: 863,
        artist: "Billy Bragg and Wilco",
        album: "Mermaid Avenue",
        year: "1998",
        cover: "None"
    },
    {
        id: 864,
        artist: "Turbonegro",
        album: "Apocalypse Dudes",
        year: "None",
        cover: "None"
    },
    {
        id: 865,
        artist: "Fatboy Slim",
        album: "You've Come a Long Way Baby",
        year: "None",
        cover: "None"
    },
    {
        id: 866,
        artist: "David Gray",
        album: "White Ladder",
        year: "None",
        cover: "None"
    },
    {
        id: 867,
        artist: "Pulp",
        album: "This Is Hardcore",
        year: "None",
        cover: "None"
    },
    {
        id: 868,
        artist: "Lucinda Williams",
        album: "Car Wheels on a Gravel Road",
        year: "None",
        cover: "None"
    },
    {
        id: 869,
        artist: "Madonna",
        album: "Ray of Light",
        year: "None",
        cover: "None"
    },
    {
        id: 870,
        artist: "Lauryn Hill",
        album: "The Miseducation of Lauryn Hill",
        year: "None",
        cover: "None"
    },
    {
        id: 871,
        artist: "Hole",
        album: "Celebrity Skin",
        year: "None",
        cover: "None"
    },
    {
        id: 872,
        artist: "The Dandy Warhols",
        album: "Come Down",
        year: "None",
        cover: "None"
    },
    {
        id: 873,
        artist: "Mercury Rev",
        album: "Deserter's Songs",
        year: "None",
        cover: "None"
    },
    {
        id: 874,
        artist: "Queens of the Stone Age",
        album: "Queens of the Stone Age",
        year: "None",
        cover: "None"
    },
    {
        id: 875,
        artist: "Air",
        album: "Moon Safari",
        year: "1998",
        cover: "None"
    },
    {
        id: 876,
        artist: "Talvin Singh",
        album: "Ok",
        year: "None",
        cover: "None"
    },
    {
        id: 877,
        artist: "Korn",
        album: "Follow the Leader",
        year: "None",
        cover: "None"
    },
    {
        id: 878,
        artist: "Kid Rock",
        album: "Devil Without a Cause",
        year: "None",
        cover: "None"
    },
    {
        id: 879,
        artist: "Boards of Canada",
        album: "Music Has the Right to Children",
        year: "1998",
        cover: "None"
    },
    {
        id: 880,
        artist: "Suba",
        album: "Sao Paulo Confessions",
        year: "None",
        cover: "None"
    },
    {
        id: 881,
        artist: "Khaled",
        album: "Kenza",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/d067b010-1fc7-4f98-b402-9188ffb9d61a.jpg"
    },
    {
        id: 882,
        artist: "XTC",
        album: "Apple Venus",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/ebb724b6-7ab9-4173-a7c2-6b2dc22b677c.jpg"
    },
    {
        id: 883,
        artist: "Incubus",
        album: "Make Yourself",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/4e04dead-f648-46d7-8f19-a690334d637c.jpg"
    },
    {
        id: 884,
        artist: "The Magnetic Fields",
        album: "69 Love Songs",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/5eb1b474-b869-4f86-8e70-f85350ccb602.jpg"
    },
    {
        id: 885,
        artist: "Travis",
        album: "Man Who",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/9841037a-9f64-4577-a17e-b3c236a9b754.jpg"
    },
    {
        id: 886,
        artist: "Slipknot",
        album: "Slipknot",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/97b480bd-028f-4203-9cf4-c11c4ff07429.jpg"
    },
    {
        id: 887,
        artist: "Beth Orton",
        album: "Central Reservation",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/c4dc5ca8-dc5b-400d-aa9e-b8f80f227625.jpg"
    },
    {
        id: 888,
        artist: "Nitin Sawhney",
        album: "Beyond Skin",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/3148a153-6706-4e6d-96f7-12ade5b43bfd.jpg"
    },
    {
        id: 889,
        artist: "Death in Vegas",
        album: "Contino Sessions",
        year: "None",
        cover: "None"
    },
    {
        id: 890,
        artist: "Moby",
        album: "Play",
        year: "None",
        cover: "None"
    },
    {
        id: 891,
        artist: "The Flaming Lips",
        album: "The Soft Bulletin",
        year: "None",
        cover: "None"
    },
    {
        id: 892,
        artist: "Les Rythmes Digitales",
        album: "Darkdancer",
        year: "None",
        cover: "None"
    },
    {
        id: 893,
        artist: "Le Tigre",
        album: "Le Tigre",
        year: "None",
        cover: "None"
    },
    {
        id: 894,
        artist: "Eminem",
        album: "The Slim Shady LP",
        year: "None",
        cover: "None"
    },
    {
        id: 895,
        artist: "Metallica",
        album: "S&M",
        year: "None",
        cover: "None"
    },
    {
        id: 896,
        artist: "Will Oldham",
        album: "I See a Darkness",
        year: "None",
        cover: "None"
    },
    {
        id: 897,
        artist: "Shack",
        album: "H.M.S. Fable",
        year: "None",
        cover: "None"
    },
    {
        id: 898,
        artist: "Basement Jaxx",
        album: "Remedy",
        year: "1999",
        cover: "None"
    },
    {
        id: 899,
        artist: "Britney Spears",
        album: "....Baby One More Time",
        year: "None",
        cover: "None"
    },
    {
        id: 900,
        artist: "Red Hot Chili Peppers",
        album: "Californication",
        year: "None",
        cover: "None"
    },
    {
        id: 901,
        artist: "Sigur Rós",
        album: "Ágætis Byrjun",
        year: "None",
        cover: "None"
    },
    {
        id: 902,
        artist: "Skunk Anansie",
        album: "Post Orgasmic Chill",
        year: "None",
        cover: "None"
    },
    {
        id: 903,
        artist: "Doves",
        album: "Lost Souls",
        year: "None",
        cover: "None"
    },
    {
        id: 904,
        artist: "Air",
        album: "The Virgin Suicides",
        year: "2000",
        cover: "None"
    },
    {
        id: 905,
        artist: "Ryan Adams",
        album: "Heartbreaker",
        year: "None",
        cover: "None"
    },
    {
        id: 906,
        artist: "Bebel Gilberto",
        album: "Tanto Tempo",
        year: "None",
        cover: "None"
    },
    {
        id: 907,
        artist: "M. J. Cole",
        album: "Sincere",
        year: "None",
        cover: "None"
    },
    {
        id: 908,
        artist: "Limp Bizkit",
        album: "Chocolate Starfish and the Hot Dog Flavored Water",
        year: "None",
        cover: "None"
    },
    {
        id: 909,
        artist: "Emmylou Harris",
        album: "Red Dirt Girl",
        year: "None",
        cover: "None"
    },
    {
        id: 910,
        artist: "Radiohead",
        album: "Kid A",
        year: "2000",
        cover: "None"
    },
    {
        id: 911,
        artist: "Badly Drawn Boy",
        album: "Hour of Bewilderbeast",
        year: "None",
        cover: "None"
    },
    {
        id: 912,
        artist: "U2",
        album: "All That You Can't Leave Behind",
        year: "None",
        cover: "None"
    },
    {
        id: 913,
        artist: "Coldplay",
        album: "Parachutes",
        year: "None",
        cover: "None"
    },
    {
        id: 914,
        artist: "Elliott Smith",
        album: "Figure 8",
        year: "None",
        cover: "None"
    },
    {
        id: 915,
        artist: "Erykah Badu",
        album: "Mama's Gun",
        year: "None",
        cover: "None"
    },
    {
        id: 916,
        artist: "Madonna",
        album: "Music",
        year: "None",
        cover: "None"
    },
    {
        id: 917,
        artist: "PJ Harvey",
        album: "Stories From the City, Stories From the Sea",
        year: "None",
        cover: "None"
    },
    {
        id: 918,
        artist: "Mike Ladd",
        album: "Welcome to the Afterfuture",
        year: "None",
        cover: "None"
    },
    {
        id: 919,
        artist: "Lambchop",
        album: "Nixion",
        year: "None",
        cover: "None"
    },
    {
        id: 920,
        artist: "Linkin Park",
        album: "Hybrid Theory",
        year: "None",
        cover: "None"
    },
    {
        id: 921,
        artist: "Goldfrapp",
        album: "Felt Mountain",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/3060842a-b087-4fca-865b-5ffdcdf85bc1.jpg"
    },
    {
        id: 922,
        artist: "Eminem",
        album: "The Marshall Mathers LP",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/7c03bf07-c2cf-4933-8988-8af82a5a21d8.jpg"
    },
    {
        id: 923,
        artist: "Red Snapper",
        album: "Our Aim Is to Satisfy",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/834a2d59-4c62-4410-a14a-e4cb98a6d47a.jpg"
    },
    {
        id: 924,
        artist: "Ute Lemper",
        album: "Punishing Kiss",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/1d19dd74-b73b-4e6d-8919-6487d1a9f4a8.jpg"
    },
    {
        id: 925,
        artist: "The Avalanches",
        album: "Since I Left You",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/57e4c664-94f3-4625-8bdc-91027ab8401d.jpg"
    },
    {
        id: 926,
        artist: "Outkast",
        album: "Stankonia",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/8c6f7f84-ef01-46a4-84de-d83c1feeec3f.jpg"
    },
    {
        id: 927,
        artist: "Common",
        album: "Like Water for Chocolate",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/f2808557-fe3c-4209-8d95-d1db8d83b513.jpg"
    },
    {
        id: 928,
        artist: "Silver Jews",
        album: "Bright Flight",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/920720ce-a918-4c3c-ae3b-d255c6b412e2.jpg"
    },
    {
        id: 929,
        artist: "Giant Sand",
        album: "Chore of Enchantment",
        year: "None",
        cover: "None"
    },
    {
        id: 930,
        artist: "Björk",
        album: "Vespertine",
        year: "2001",
        cover: "None"
    },
    {
        id: 931,
        artist: "Radiohead",
        album: "Amnesiac",
        year: "None",
        cover: "None"
    },
    {
        id: 932,
        artist: "Ryan Adams",
        album: "Gold",
        year: "None",
        cover: "None"
    },
    {
        id: 933,
        artist: "Gorillaz",
        album: "Gorillaz",
        year: "None",
        cover: "None"
    },
    {
        id: 934,
        artist: "The Strokes",
        album: "Is This It",
        year: "2001",
        cover: "None"
    },
    {
        id: 935,
        artist: "Survivor",
        album: "Destiny's Child",
        year: "None",
        cover: "None"
    },
    {
        id: 936,
        artist: "Gillian Welch",
        album: "The Revelator",
        year: "None",
        cover: "None"
    },
    {
        id: 937,
        artist: "Gotan Project",
        album: "La Revancha Del Tango",
        year: "2001",
        cover: "None"
    },
    {
        id: 938,
        artist: "The White Stripes",
        album: "White Blood Cells",
        year: "2001",
        cover: "None"
    },
    {
        id: 939,
        artist: "The Beta Band",
        album: "Hot Shots II",
        year: "None",
        cover: "None"
    },
    {
        id: 940,
        artist: "The Hives",
        album: "Your New Favourite Band",
        year: "None",
        cover: "None"
    },
    {
        id: 941,
        artist: "Jay Z",
        album: "The Blueprint (",
        year: "2001",
        cover: "None"
    },
    {
        id: 942,
        artist: "Röyksopp",
        album: "Melody A.M.",
        year: "2001",
        cover: "None"
    },
    {
        id: 943,
        artist: "Drive-By Truckers",
        album: "Southern Rock Opera",
        year: "None",
        cover: "None"
    },
    {
        id: 944,
        artist: "Super Furry Animals",
        album: "Rings Around the World",
        year: "None",
        cover: "None"
    },
    {
        id: 945,
        artist: "The Vines",
        album: "Highly Evolved",
        year: "None",
        cover: "None"
    },
    {
        id: 946,
        artist: "Jurassic 5",
        album: "Power in Numbers",
        year: "None",
        cover: "None"
    },
    {
        id: 947,
        artist: "Wilco",
        album: "Yankee Hotel Foxtrot",
        year: "None",
        cover: "None"
    },
    {
        id: 948,
        artist: "Christina Aguilera",
        album: "Stripped",
        year: "None",
        cover: "None"
    },
    {
        id: 949,
        artist: "Coldplay",
        album: "A Rush of Blood to the Head",
        year: "None",
        cover: "None"
    },
    {
        id: 950,
        artist: "Ms Dynamite",
        album: "A Little Deeper",
        year: "None",
        cover: "None"
    },
    {
        id: 951,
        artist: "Norah Jones",
        album: "Come Away With Me",
        year: "None",
        cover: "None"
    },
    {
        id: 952,
        artist: "The Flaming Lips",
        album: "Yoshimi Battles the Pink Robots",
        year: "2002",
        cover: "None"
    },
    {
        id: 953,
        artist: "Johnny Cash",
        album: "American IV: The Man Comes Around",
        year: "2002",
        cover: "None"
    },
    {
        id: 954,
        artist: "Doves",
        album: "The Last Broadcast",
        year: "None",
        cover: "None"
    },
    {
        id: 955,
        artist: "Justin Timberlake",
        album: "Justified",
        year: "None",
        cover: "None"
    },
    {
        id: 956,
        artist: "Bruce Springsteen",
        album: "The Rising",
        year: "None",
        cover: "None"
    },
    {
        id: 957,
        artist: "The Bees",
        album: "Sunshine Hit Me",
        year: "None",
        cover: "None"
    },
    {
        id: 958,
        artist: "The Roots",
        album: "Phrenology",
        year: "None",
        cover: "None"
    },
    {
        id: 959,
        artist: "Beck",
        album: "Sea Change",
        year: "None",
        cover: "None"
    },
    {
        id: 960,
        artist: "The Coral",
        album: "The Coral",
        year: "None",
        cover: "None"
    },
    {
        id: 961,
        artist: "Missy Elliott",
        album: "Under Construction",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/45ad643d-ad87-4fc3-bc87-fde3502134dd.jpg"
    },
    {
        id: 962,
        artist: "Outkast",
        album: "Speakerboxxx/The Love Below",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/3cb66216-6a6e-44a0-8c91-a6f2dc02c16b.jpg"
    },
    {
        id: 963,
        artist: "Calexico",
        album: "Feast of Wire",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/be4ec972-6645-4370-a9b0-efdacae89d77.jpg"
    },
    {
        id: 964,
        artist: "Radiohead",
        album: "Hail to the Thief",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/63b72538-d4f2-4b34-9776-ff2e5fe42cfb.jpg"
    },
    {
        id: 965,
        artist: "The Darkness",
        album: "Permission to Land",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/0bc41be0-8d51-434f-9de4-26cdf06afd48.jpg"
    },
    {
        id: 966,
        artist: "50 Cent",
        album: "Get Rich or Die Tryin'",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/9326cfd7-626a-4014-81c0-cbbfc5571ba9.jpg"
    },
    {
        id: 967,
        artist: "Dizzee Rascal",
        album: "Boy in Da Corner",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/33a43708-0427-49ba-a5a8-a5cd139b38b9.jpg"
    },
    {
        id: 968,
        artist: "The Mars Volta",
        album: "De-Loused in the Comatorium",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/8b64c80a-fad5-47be-81f9-063fb85c6036.jpg"
    },
    {
        id: 969,
        artist: "Lightning Bolt",
        album: "Wonderful Rainbow",
        year: "2003",
        cover: "None"
    },
    {
        id: 970,
        artist: "The White Stripes",
        album: "Elephant",
        year: "None",
        cover: "None"
    },
    {
        id: 971,
        artist: "Kings of Leon",
        album: "Youth and Young Manhood",
        year: "None",
        cover: "None"
    },
    {
        id: 972,
        artist: "Rufus Wainwright",
        album: "Want One",
        year: "None",
        cover: "None"
    },
    {
        id: 973,
        artist: "The Thrills",
        album: "So Much for the City",
        year: "None",
        cover: "None"
    },
    {
        id: 974,
        artist: "Yeah Yeah Yeahs",
        album: "Fever to Tell",
        year: "None",
        cover: "None"
    },
    {
        id: 975,
        artist: "Amy Winehouse",
        album: "Frank",
        year: "None",
        cover: "None"
    },
    {
        id: 976,
        artist: "Devendra Banhart",
        album: "Rejoicing in the Hands",
        year: "None",
        cover: "None"
    },
    {
        id: 977,
        artist: "Nick Cave and the Bad Seeds",
        album: "The Lyre of Orpheus/Abattoir Blues",
        year: "None",
        cover: "None"
    },
    {
        id: 978,
        artist: "Scissor Sisters",
        album: "Scissor Sister",
        year: "None",
        cover: "None"
    },
    {
        id: 979,
        artist: "Franz Ferdinand",
        album: "Franz Ferdinand",
        year: "2004",
        cover: "None"
    },
    {
        id: 980,
        artist: "Bjork",
        album: "Medulla",
        year: "None",
        cover: "None"
    },
    {
        id: 981,
        artist: "N.E.R.D",
        album: "Fly or Die",
        year: "None",
        cover: "None"
    },
    {
        id: 982,
        artist: "Kanye West",
        album: "The College Dropout",
        year: "None",
        cover: "None"
    },
    {
        id: 983,
        artist: "Cee-Lo Green",
        album: "...Is the Soul Machine",
        year: "None",
        cover: "None"
    },
    {
        id: 984,
        artist: "Kings of Leon",
        album: "Aha Shake Heartbreak",
        year: "None",
        cover: "None"
    },
    {
        id: 985,
        artist: "Mylo",
        album: "Destroy Rock and Roll",
        year: "None",
        cover: "None"
    },
    {
        id: 986,
        artist: "Ozamatli",
        album: "Street Sings",
        year: "None",
        cover: "None"
    },
    {
        id: 987,
        artist: "The Streets",
        album: "A Grand Don't Come for Free",
        year: "None",
        cover: "None"
    },
    {
        id: 988,
        artist: "Brian Wilson",
        album: "Smile",
        year: "None",
        cover: "None"
    },
    {
        id: 989,
        artist: "The Beta Band",
        album: "Heroes to Zeros",
        year: "None",
        cover: "None"
    },
    {
        id: 990,
        artist: "Rufus Wainwright",
        album: "Want Two",
        year: "None",
        cover: "None"
    },
    {
        id: 991,
        artist: "The Libertines",
        album: "The Libertines",
        year: "None",
        cover: "None"
    },
    {
        id: 992,
        artist: "TV on the Radio",
        album: "Desperate Youth, Blood Thirsty Babes",
        year: "None",
        cover: "None"
    },
    {
        id: 993,
        artist: "Liars",
        album: "They Were Wrong So We Drowned",
        year: "None",
        cover: "None"
    },
    {
        id: 994,
        artist: "Arcade Fire",
        album: "Funeral",
        year: "None",
        cover: "None"
    },
    {
        id: 995,
        artist: "The Zutons",
        album: "Who Killed the Zutons",
        year: "None",
        cover: "None"
    },
    {
        id: 996,
        artist: "The Killers",
        album: "Hot Fuss",
        year: "None",
        cover: "None"
    },
    {
        id: 997,
        artist: "Green Day",
        album: "American Idiot",
        year: "None",
        cover: "None"
    },
    {
        id: 998,
        artist: "The Icarus Line",
        album: "Penance Soiree",
        year: "None",
        cover: "None"
    },
    {
        id: 999,
        artist: "Morrissey",
        album: "You Are the Quarry",
        year: "None",
        cover: "None"
    },
    {
        id: 1000,
        artist: "M.I.A.",
        album: "Arular",
        year: "None",
        cover: "None"
    },
    {
        id: 1001,
        artist: "Common",
        album: "Be",
        year: "2005",
        cover: "https://www.listchallenges.com/f/items/44c04570-8cfc-47d2-b8c9-c35db0e69911.jpg"
    },
    {
        id: 1002,
        artist: "Antony & the Johnsons",
        album: "I Am a Bird Now",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/b49279e5-7a9a-4e94-a4b3-d7a10abb5d79.jpg"
    },
    {
        id: 1003,
        artist: "Richard Hawley",
        album: "Coles Corner",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/cfbb0b11-e3e6-46b9-aab0-bf6572e6ca3b.jpg"
    },
    {
        id: 1004,
        artist: "Beck",
        album: "Guero",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/2e8e49ba-ee33-4c02-b2d9-b7ad66fec2ee.jpg"
    },
    {
        id: 1005,
        artist: "Sufjan Stevens",
        album: "Illinois",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/3520c55f-3b56-4cb9-8999-c6c342984241.jpg"
    },
    {
        id: 1006,
        artist: "The White Stripes",
        album: "Get Behind Me Satan",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/df2c2380-60f5-4fe8-aaad-ef5861d7b4af.jpg"
    },
    {
        id: 1007,
        artist: "Amy Winehouse",
        album: "Back to Black",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/4f32ac21-1074-4828-9026-0e88fb568f92.jpg"
    },
    {
        id: 1008,
        artist: "Christina Aguilera",
        album: "Back to Basics",
        year: "None",
        cover: "https://www.listchallenges.com/f/items/76b9e95a-a969-4e89-9fdc-76f0758ce9cc.jpg"
    },
    {
        id: 1009,
        artist: "Lupe Fiasco",
        album: "Food & Liquor",
        year: "None",
        cover: "None"
    },
    {
        id: 1010,
        artist: "Ghostface Killah",
        album: "Fishscale",
        year: "None",
        cover: "None"
    },
    {
        id: 1011,
        artist: "Ali Farka Touré",
        album: "Savane",
        year: "None",
        cover: "None"
    },
    {
        id: 1012,
        artist: "Muse",
        album: "Black Holes and Revelations",
        year: "None",
        cover: "None"
    },
    {
        id: 1013,
        artist: "Joanna Newsom",
        album: "YS",
        year: "None",
        cover: "None"
    },
    {
        id: 1014,
        artist: "Arctic Monkeys",
        album: "Whatever People Say I Am, That's What I'm Not",
        year: "None",
        cover: "None"
    },
    {
        id: 1015,
        artist: "Klaxons",
        album: "Myths of the Near Future",
        year: "None",
        cover: "None"
    },
    {
        id: 1016,
        artist: "LCD Soundsystem",
        album: "Sound of Silver",
        year: "None",
        cover: "None"
    },
    {
        id: 1017,
        artist: "Radiohead",
        album: "In Rainbows",
        year: "None",
        cover: "None"
    },
    {
        id: 1018,
        artist: "Arcade Fire",
        album: "Neon Bible",
        year: "None",
        cover: "None"
    },
    {
        id: 1019,
        artist: "MIA",
        album: "Kala",
        year: "None",
        cover: "None"
    },
    {
        id: 1020,
        artist: "The Good, the Bad & the Queen",
        album: "The Good, the Bad & the Queen",
        year: "None",
        cover: "None"
    },
    {
        id: 1021,
        artist: "Justice",
        album: "Cross",
        year: "None",
        cover: "None"
    },
    {
        id: 1022,
        artist: "Q-Tip",
        album: "The Renaissance",
        year: "None",
        cover: "None"
    },
    {
        id: 1023,
        artist: "Kings of Leon",
        album: "Only by the Night",
        year: "None",
        cover: "None"
    },
    {
        id: 1024,
        artist: "Fleet Foxes",
        album: "Fleet Foxes",
        year: "None",
        cover: "None"
    },
    {
        id: 1025,
        artist: "None",
        album: "None",
        year: "None",
        cover: "None"
    },
    {
        id: 1026,
        artist: "Elbow",
        album: "The Seldom Seen Kid",
        year: "None",
        cover: "None"
    },
    {
        id: 1027,
        artist: "Portishead",
        album: "Third",
        year: "None",
        cover: "None"
    },
    {
        id: 1028,
        artist: "MGMT",
        album: "Oracular Spectacular",
        year: "None",
        cover: "None"
    },
    {
        id: 1029,
        artist: "Goldfrapp",
        album: "Seventh Tree",
        year: "None",
        cover: "None"
    },
    {
        id: 1030,
        artist: "TV on the Radio",
        album: "Dear Science",
        year: "None",
        cover: "None"
    },
    {
        id: 1031,
        artist: "Slipknot",
        album: "All Hope Is Gone",
        year: "None",
        cover: "None"
    },
    {
        id: 1032,
        artist: "Wild Beasts",
        album: "Two Dancers",
        year: "None",
        cover: "None"
    },
    {
        id: 1033,
        artist: "Bill Callahan",
        album: "Sometimes I Wish We Were an Eagle",
        year: "None",
        cover: "None"
    },
    {
        id: 1034,
        artist: "Animal Collective",
        album: "Merriweather Post Pavilion",
        year: "2009",
        cover: "None"
    },
    {
        id: 1035,
        artist: "Grizzly Bear",
        album: "Veckatimest",
        year: "None",
        cover: "None"
    },
    {
        id: 1036,
        artist: "Yeah Yeah Yeahs",
        album: "It's Blitz!",
        year: "None",
        cover: "None"
    },
    {
        id: 1037,
        artist: "Dirty Projectors",
        album: "Bitte Orca",
        year: "None",
        cover: "None"
    },
    {
        id: 1038,
        artist: "The Xx",
        album: "Xx",
        year: "None",
        cover: "None"
    },
    {
        id: 1039,
        artist: "Fever Ray",
        album: "Fever Ray",
        year: "None",
        cover: "None"
    },
    {
        id: 1040,
        artist: "Beach House",
        album: "Teen Dream",
        year: "None",
        cover: "None"
    }
];
